module.exports = {
  // заглушка если текста нет
  ' ': ' ',

  // start Nav.
  'nav.burger': 'Меню',
  'nav.ru': 'Русский',
  'nav.en': 'English',
  'nav.signin': 'Вход',
  'nav.signup': 'Регистрация',
  'nav.forgot_password': 'Забыли пароль?',
  'nav.create': 'Зарегистрироваться',
  'nav.im_teacher': 'Я учитель',
  'nav.im_student': 'Я ученик',
  'nav.register_modal_title': 'В качестве кого Вы хотите зарегистрироваться?',
  // end Nav

  // start Sidebar
  'sidebar.settings': 'Настройки',
  'sidebar.change_password': 'Сменить пароль',
  'sidebar.logout': 'Выйти',
  'sidebar.homeworks.await': 'Ждет выполнения',
  'sidebar.homeworks.check': 'На проверку',
  'sidebar.homeworks.history': 'История заданий',
  // end Sidebar

  // start sign up
  'signup.title': 'Регистрация',
  'signup.subtitle': 'Ввести данные',
  'signup.btn_title': 'Зарегистрироваться',
  INVALID_TOKEN: 'Неверный код.',
  VALIDATION_EMAIL_ALREADY_EXIST: 'Данный email адрес уже существует.',
  VALIDATION_EMAIL_ALREADY_USED: 'Данный email адрес уже занят',
  'signup.success_message':
    'На указанную почту отправлено письмо со ссылкой для подтверждения регистрации. Если оно не приходит, вернитесь на страницу регистрации, чтобы ввести данные заново, или обратитесь в техническую поддержку.',
  // end sign up

  // start verify
  'verify.success_message': 'Вы успешно зарегистрировались. Чтобы войти, ',
  'verify.success_message_link': 'введите логин и пароль',
  // end verify

  // start resend
  'resend.success_message': 'Письмо отправлено',
  // end resend

  // start sign in
  'signin.title': 'Вход',
  'signin.subtitle': 'Введите свои данные',
  'signin.password_old': 'Старый пароль',
  'signin.password_new': 'Новый пароль',
  'signin.password_confirm': 'Подтвердите новый пароль',
  'signin.btn_title': 'Войти',
  'signin.repeat':
    'Регистрация не подтверждена. Следуйте инструкции в письме. {repeat} отправку подтверждающего письма',
  // end sign in

  // start logout
  'logout.title': 'Выход из учётной записи',
  'logout.success_message': 'Сеанс завершён',
  // end logout

  // start forgot-password
  'forgotPassword.title': 'Забыли пароль?',
  'forgotPassword.subtitle': 'Создайте новый, чтобы войти в учётную запись',
  'forgotPassword.btn_title': 'Отправить',
  'forgotPassword.success_message':
    'На указанную почту отправлено письмо со ссылкой для сброса пароля. Если оно не приходит, вернитесь на страницу сброса пароля и попробуйте заново, или обратитесь в техническую поддержку.',
  // end forgot-password

  // start reset-password
  'resetPassword.title': 'Форма сброса пароля',
  'resetPassword.btn_title': 'Сбросить',
  'resetPassword.success_message': 'Пароль сброшен.',
  // end reset-password

  // start page ChangePassword
  'changePassword.title': 'Сменить пароль',
  'changePassword.btn_title': 'Сменить',
  'changePassword.success_message':
    'Вы успешно изменили пароль. Запомните или запишите его',
  // end page ChangePassword

  // start page Home
  'home.title': 'ЗДЕСЬ БУДЕТ ПРИВЕТСВЕННЫЙ ТЕКСТ И КАРТИНКИ',
  // end page Home

  // start page NotFound
  'notFound.title': 'Ошибка 404.',
  'notFound.subtitle': 'Страница не существует',
  // end page NotFound

  // start page Forms
  'form.email': 'почта',
  'form.password': 'пароль',
  'form.password_old': 'старый пароль',
  'form.password_new': 'новый пароль',
  'form.confirm_password': 'подтвердить',
  'form.agree': 'Я согласен с ....',
  'form.code': 'Код',
  'form.error_required': 'Обязательно',
  'form.error_invalid_email': 'Неправильный адрес электронной почты',
  'form.error_invalid_phone': 'Неправильный телефон (требуется 11 цифр)',
  'form.error_password_min': 'Не менее {min} знаков',
  'form.error_password_letters': 'Должен содержать буквы',
  'form.error_password_num': 'Должен содержать цифры',
  'form.error_password_match': 'Пароли не совпадают',
  // end page Forms

  // common word
  'common.repeat': 'Повторить',
  'common.success_message': 'Успешно',
  // end cpmmom word

  // SUCCES_USER_UPDATE: "Пользователь успешно "
  'notice.success': 'Успешно',
  SAVED: 'Сохранено',

  // Validate
  MUST_BE_CONTAINS_LETTERS: 'Пароль должен включать минимум 1 латинскую букву',
  MUST_BE_CONTAINS_NUMBER: 'Пароль должен включать числа',
  MUST_BE_7_CHARACTERS_OR_MORE: 'Пароль должен содержать 7 или более символов',
  MUST_BE_4_CHARACTERS_OR_MORE: 'Пароль должен содержать 4 или более символов',
  MUST_BE_NUMERIC: 'Поле должно быть числом',
  MUST_BE_POSITIVE: 'Сумма должна быть больше 0',
  REQUIRED: 'Поле обязательно для заполнения',
  PASSWORD_DO_NOT_MATCH: 'Пароли не совпадают',
  INVALID_EMAIL_ADDRESS: 'Некорректный email адрес',
  UNACCEPTABLE_SIGNS: 'Недопустимые символы, пробелы',
  INVALID_DATE: 'Дата должна быть указана в формате DD.MM.YYYY (ДД.ММ.ГГГГ)',
  TIMETABLE_ERROR: 'Укажите график выполнения задания',
  // end Validate

  // Errors
  INVALID_LOGIN_DATA: 'Некорректный email или пароль.',
  CANNOT_FOUND_USER_WITH_THIS_EMAIL: 'Пользователь с таким email не найден.',
  INVALID_OLD_PASSWORD: 'Неверно указан старый пароль',
  EMPTY_OR_VERY_SHORT_PASSWORD: 'Не указан или слишком короткий пароль',
  // End errors

  // Stub
  simulators: 'Тренажеры',
  stub1: 'Справочники',
  reports: 'Отчеты',
  // End Stub

  // Главный фильтр (Правило)
  RULE_SIMPLE_SUM: 'Прямой счет',
  RULE_FIVE_SUM: 'Формулы на 5',
  RULE_TEN_SUM: 'Формула на 10',
  RULE_FIVE_AND_TEN_SUM: 'Формула на 5 и 10',
  NO_MODE: 'Произвольные',

  // Главный фильтр

  // Меню
  DIRECTORY: 'Справочники',
  ARCHIVE: 'Архив',

  // Student
  // Table
  STUDENT_TITLE: 'Ученики',
  STUDENT_TITLE_SINGULAR: 'Ученика',
  STUDENT_FORM_LEFT_PATH_TITLE: 'Данные ученика',
  STUDENT_FORM_RIGTH_PATH_TITLE: 'Данные родителя',
  STUDENT_TABLE_CREATE_TITLE: 'Добавить нового ученика',
  STUDENT_TABLE_SAVE_TITLE: 'Редактировать данные ученика',
  STUDENT_TABLE_CREATE: 'Список учеников без педагога',
  STUDENT_TABLE_INVITE: 'Выслать приглашение',
  STUDENT_TABLE_REGISTER: 'Зарегистрировать ученика',
  STUDENT_TABLE_SAVE: 'Сохранить',
  STUDENT_ADD: 'Добавить ученика',
  STUDENT_SUCCESS_CREATE_MESSAGE: 'Ученик добавлен',
  STUDENT_SUCCESS_SAVE_MESSAGE: 'Ученик успешно изменен',

  // Group
  // Table
  GROUP_TITLE: 'Группы',
  GROUP_TITLE_SINGULAR: 'Группа',
  GROUP_FORM_LEFT_PATH_TITLE: 'Основные поля',
  GROUP_FORM_RIGTH_PATH_TITLE: 'Дополнительные поля',
  GROUP_TABLE_CREATE_TITLE: 'Добавить новую группу',
  GROUP_TABLE_SAVE_TITLE: 'Редактировать данные группы',
  GROUP_TABLE_CREATE: 'Добавить',
  GROUP_TABLE_SAVE: 'Сохранить',
  GROUP_SUCCESS_CREATE_MESSAGE: 'Группа добавлена',
  GROUP_SUCCESS_SAVE_MESSAGE: 'Группа успешно изменена',

  // School
  // Table
  SCHOOL_TITLE: 'Школы',
  SCHOOL_FORM_LEFT_PATH_TITLE: 'Данные руководителя школы',
  SCHOOL_FORM_RIGTH_PATH_TITLE: 'Данные школы',
  SCHOOL_TABLE_CREATE_TITLE: 'Добавить новую школу',
  SCHOOL_TABLE_SAVE_TITLE: 'Редактировать данные школы',
  SCHOOL_TABLE_CREATE: 'Добавить',
  SCHOOL_TABLE_SAVE: 'Сохранить',
  SCHOOL_SUCCESS_CREATE_MESSAGE: 'Школа добавлена',
  SCHOOL_SUCCESS_SAVE_MESSAGE: 'Школа успешно изменена',
  SCHOOL_INFO: 'Информация о школе',

  // Teacher
  // Table
  TEACHER_TITLE: 'Педагоги',
  TEACHER_FORM_LEFT_PATH_TITLE: 'Основные поля',
  TEACHER_FORM_RIGTH_PATH_TITLE: 'Дополнительные поля',
  TEACHER_TABLE_CREATE_TITLE: 'Добавить нового педагога',
  TEACHER_TABLE_SAVE_TITLE: 'Редактировать данные педагога',
  TEACHER_TABLE_CREATE: 'Добавить',
  TEACHER_TABLE_SAVE: 'Сохранить',
  TEACHER_SUCCESS_CREATE_MESSAGE: 'Педагог добавлен',
  TEACHER_SUCCESS_SAVE_MESSAGE: 'Педагог успешно изменен',

  // Homework
  // Table
  HOMEWORK_TITLE: 'Домашнее задание',
  HOMEWORK_TITLE_SETTINGS: 'Настройки домашних заданий',
  HOMEWORK_TITLE_SINGULAR: 'Домашнее задание',
  HOMEWORK_FORM_LEFT_PATH_TITLE: 'Настройки параметров',
  HOMEWORK_FORM_RIGTH_PATH_TITLE: 'Настройки пользователей',
  HOMEWORK_TABLE_CREATE_TITLE: 'Создать',
  HOMEWORK_TABLE_SAVE_TITLE: 'Редактировать',
  HOMEWORK_TABLE_CREATE: 'Создать',
  HOMEWORK_TABLE_SAVE: 'Сохранить',
  HOMEWORK_SUCCESS_CREATE_MESSAGE: 'Домашнее задание(я) добавлено(ы)',
  HOMEWORK_SUCCESS_SAVE_MESSAGE: 'Домашнее задание успешно изменено',
  HOMEWORK_STARTED_CARRY_OUT: 'Приступил(а) к выполнению',
  LAST_WEEK_DATES:
    'Проверенные домашние задания отображаются промежутком в семь дней, в зависимости от даты выполнения',

  // Table
  EXAMS_TITLE: 'Экзамен',
  EXAMS_TITLE_SINGULAR: 'Экзамен',
  EXAMS_FORM_LEFT_PATH_TITLE: 'Параметры экзамена',
  EXAMS_FORM_RIGTH_PATH_TITLE: 'Статистика экзамена',
  EXAMS_TABLE_CREATE_TITLE: 'Добавить новый экзамен',
  EXAMS_TABLE_SAVE_TITLE: 'Редактировать экзамен',
  EXAMS_TABLE_CREATE: 'Создать',
  EXAMS_TABLE_SAVE: 'Сохранить',
  EXAMS_SUCCESS_CREATE_MESSAGE: 'Экзамен успешно создан',
  EXAMS_SUCCESS_RESULT: 'Результаты экзамена успешно сохранены',
  EXAMS_SUCCESS_SAVE_MESSAGE: 'Данные экзамена успешно изменены',
  EXAM_SUCCESS_SAVE: 'Ссылка успешно сохранена',

  // Book
  // Table
  WORKBOOK_BUTTON: 'Создать примеры',
  WORKBOOK_TITLE: 'Примеры на печать',
  CERTIFICATION_TITLE: 'Сертификация',
  CERTIFICATION_SIMULATE_TITLE: 'Симуляция',
  SIMULATE_PAUSE: 'Симуляция олимпиады приостановлена. Ожидайте',
  CERTIFICATION_SIMULATE_SAMA_TITLE: 'Симуляция SAMA GLOBAL',
  CERTIFICATION_SIMULATE_PAMA_TITLE: 'Симуляция PAMA GLOBAL',
  CERTIFICATION_SIMULATE_UAMAP_TITLE: 'Симуляция UAMAP',
  CERTIFICATION_EXAM_TITLE: 'Экзамен',
  BOOK_TITLE: 'Командная работа',
  WORKBOOK_TO_PRINT: 'Отправить на печать',

  CAR_ICON: 'Машинка',
  PLANE_ICON: 'Cамолет',
  ELEPHANT_ICON: 'Cлоненок',
  HELICOPTER_ICON: 'Вертолетик',
  TIGER_ICON: 'Тигрёнок',
  FOX_ICON: 'Лисенок',
  FAWN_ICON: 'Олененок',
  CROCODILE_ICON: 'Крокодил',
  SQUIRREL_ICON: 'Бельчонок',
  BEAR_ICON: 'Мишка',
  WOLF_ICON: 'Волчонок',
  LEOPARD_ICON: 'Леопард',

  COLUMN: 'Столбики',
  SIMULATORS: 'Тренажеры',
  EDIT_PROFILE: 'Редактировать профиль',
  EXIT_INSIDE_PROFILE: 'Выйти из профиля',
  NAME: 'Имя',
  SURNAME: 'Фамилия',
  NAME_EN: 'Имя на англ. яз.',
  SURNAME_EN: 'Фамилия на англ. яз.',
  SEX: 'Пол',
  MIDDLE_NAME: 'Отчество',
  STATUS: 'СТАТУС',
  TRANSACTION_STATUS: 'Статус',
  EXAM_LINK: 'Ссылка на Yandex',
  CITY: 'Город',
  EMAIL: 'Электронный адрес',
  EMAIL_SHORT: 'Эл. Почта',
  PHOTO_LINK: 'Ссылка на  фото участника',
  MAIN_PAGE_ROOMA_TITLE: 'быстрый доступ: Анзан',
  MAIN_PAGE_ROOMA_DESCRIPTION:
    'В этом разделе Вы можете просматривать улучшить свои навыки',
  MAIN_PAGE_ROOMB_TITLE: 'быстрый доступ: Столбики',
  MAIN_PAGE_ROOMB_DESCRIPTION:
    'В этом разделе Вы можете просматривать улучшить свои навыки',
  MAIN_PAGE_ROOMC_TITLE: 'быстрый доступ: Флэш-карты',
  MAIN_PAGE_ROOMC_DESCRIPTION:
    'В этом разделе Вы можете просматривать улучшить свои навыки',
  DETAIL: 'Подробнее...',
  SET_YOUR_DATE_OF_BIRTH: 'укажите дату рождения',
  ROLE_GUEST: 'Неавторизованый',
  ROLE_STUDENT: 'Ученик',
  ROLE_TEACHER: 'Педагог',
  ROLE_SCHOOL: 'Школа',
  ROLE_ADMIN: 'Администратор',
  ROLE: 'Тип пользователя',
  CABINET: 'Кабинет',
  SETTINGS: 'Настройки',
  BASIC_SETTINGS: 'Основные настройки:',
  ADDITIONAL_SETTINGS: 'Детальные настройки:',
  TRAINER_SETTINGS: 'Настройки тренажера',
  room: 'Комната',
  amount: 'Количество примеров',
  OLIMPIC_SAMPLES_TITLE: 'примеров',
  section: 'Раздел',
  animation: 'Анимация',
  windows: 'Количество экранов',
  simulator: 'Тренажер',
  steps: 'Количество чисел',
  period: 'Пауза между примерами',
  INTERVAL: 'Скорость показа',
  interval: 'Скорость показа',
  ACTIVATE_NEGATIVE: 'Включить отрицательные числа',
  NEGATIVE_ANSWER: 'Отрицательный конечный ответ',
  mode: 'Тема',

  sign: 'Знак',
  bound: 'Переход',
  under: 'от',
  over: 'до',
  of: 'из',
  rule: 'Правило',
  numbers: 'Раздел',
  formulas: 'Формула(ы) на число(а): ',
  formulas_once: 'Формула(ы):',
  student: 'Ученик',
  students: 'Ученик(и)',
  individ: 'Индивидуально',
  date: 'Дата',
  dates: 'Дата(ы)',
  daily: 'Ежедневно',
  daily_over: 'Ежедневно до',
  numbers_of_terms: 'Кол-во чисел',
  numbers_in_example: 'Кол-во чисел в примере',
  comment: 'Комментарий',
  first_int_available_numbers: 'Первый множитель',
  second_int_available_numbers: 'Второй множитель',
  order_first_int_available_numbers: 'Разряд первого множителя',
  order_second_int_available_numbers: 'Разряд второго множителя',
  DIVISION: 'Деление',
  MULTIPLICATION: 'Умножение',
  MULTIDIVISION: 'Умножение/деление',
  divider: 'Делитель',
  dividend: 'Делимое',
  FADING: 'Угасание',
  SLIDE_UP: 'Слайд вверх',
  SLIDE_DOWN: 'Слайд вниз',
  SLIDE_LEFT: 'Слайд влево',
  SLIDE_RIGHT: 'Слайд вправо',
  BIGGER_FONT: 'Больше шрифт',
  SMALLER_FONT: 'Меньше шрифт',
  RANDOM_PLACE: 'Случайное место',
  MULTICOLORED_NUMBERS: 'Разноцветные числа',
  NO_ANIMATIONS: 'Без анимаций',
  roomA: 'Анзан',
  roomB: 'Столбики',
  roomC: 'Флэш-карты',
  roomD: 'Таблица Шульте',
  anzan_title: 'Анзан',
  columns_title: 'Столбики',
  cards_title: 'Флэш-карты',
  schulte_table_title: 'Таблица Шульте',
  MINIMUM_RATE: 'Минимальный разряд ответа',
  MAXIMUM_RATE: 'Максимальный разряд ответа',
  BOTH_ARE_SMALLER: 'Оба меньше',
  BOTH_ARE_BIGGER: 'Оба больше',
  OPPOSITE_SIDES: 'По разные стороны',
  START: 'Старт',
  STOP: 'Стоп',
  MIX: 'МИКС',
  CLOSE: 'Закрыть',
  CHECK: 'Проверить',
  ANSWER: 'Ответ',
  ANSWERS: 'Ответы',
  PROGRESS: 'Загрузка',
  ENTER_ANSWER: 'Введите ответ',
  REPORT_TITLE:
    'Статистика показывает решённые задания по всем разделам: домашнее задание и задачи решённые при удаленном обучении.',
  REPORT_DESCRIPTION:
    'Количество правильных/неправильных ответов указаны на левой вертикальной шкале, медианное значение параметров: интервал, кол-во слагаемых, разряд числа - отмечены на правой вертикальной шкале.',
  NUMBER_OF_TERMS: 'Количество слагаемых',
  NUMBER_RANK: 'Разряд числа',
  digit: 'Разряд числа',
  FILTER: 'Фильтр',
  SUCCESS: 'Верно',
  FAIL: 'Не верно',
  RATE: 'Оценка',
  ADDRESS: 'Адрес',
  DESCRIPTION: 'Описание',
  FULL_NAME: 'ФИО',
  SUCCESS_ALL: 'Верно/Всего',
  OPERATION: 'Операции',
  TOTAL_TASKS: 'Всего заданий',
  TASKS: 'Заданий',
  TOTAL_SUCCESS: 'из них верно',
  REPORT_HOMEWORK:
    'Сокращения: (П) - правило, (Р) - раздел, (Ф) - формула, (З) - знак, (Вп) - Временной период, (Кч) - кол-во чисел, (Рч) - разряд числа, (Рр) - режим количества разрядов, (Пм) - первый множитель, (Вт) - второй множитель',
  ADD_HOMEWORK: 'Создать',
  DELETE_HOMEWORK: 'Удалить домашнее задание',
  DELETE_SELECTED: 'Удалить выбранные',
  SAVE_HOMEWORK: 'Завершить и сохранить',
  WARNING_HOMEWORK: 'Изменения затронут всех учеников!',
  WARNING_HOMEWORK_DELETE: 'Удалить домашнее задание?',
  WARNING_HOMEWORK_CHECK: 'Отметить домашнее задание проверенным?',
  WARNING_HOMEWORK_EDIT:
    'Ученик уже приступил к выполнению задания. Результат будет сброшен',
  WARNING_HOMEWORK_CANT_EDIT: 'Невозможно изменить выполненное задание!',
  WARNING_HOMEWORK_CANT_DELETE: 'Невозможно удалить выполненное задание!',
  SHOW_SOLUTION: 'Показать решение',
  MARK_COMPLETE: 'Оценить',
  GO_TO_HOMEWORK: 'Перейти к заданию',

  FILTER_ALL: 'Все записи',
  FILTER_TITLE: 'Фильтры',
  FILTER_RESET: 'Сбросить фильтр',

  PAGINATION_NEXT: 'Следующая',
  PAGINATION_PREVIOUS: 'Предыдущая',
  PAGINATION_ROWS_PER_PAGE: 'Записей на странице:',
  PAGINATION_DISPLAY_ROWS: 'из',

  VIEW_COLUMN_TITLE: 'Показать/скрыть столбцы',
  VIEW_COLUMN_TITLE_AREA: 'Показать/скрыть столбцы',
  VIEW: 'Показать',
  HIDE: 'Скрыть',

  BODY_NO_MATCH: 'Не найдено ни одной записи',
  BODY_NO_TOOL_TIP: 'Сортировать',
  BODY_NO_COLUMN_HEADER_TOOLTIP: 'Сортировка для ',

  SELECTED_ROWS_TEXT: 'записей отмечено',
  SELECTED_ROWS_TEXT_HOMEWORKS: 'Проверено',
  SELECTED_ROWS_DELETE: 'Удалить',
  SELECTED_ROWS_DELETE_ARIA: 'Удалить выделенные записи',
  FILTERING: 'Отфильтровать',

  NEGATIVE_NUMBERS: 'Отрицательные числа',

  SECTION_UP_TO_FOUR: 'Счет в 1,2,3,4',
  SECTION_UP_TO_FIVE: 'Счет до 5',
  SECTION_UP_TO_SIX: 'Счет до 6',
  SECTION_UP_TO_SEVEN: 'Счет до 7',
  SECTION_UP_TO_EIGHT: 'Счет до 8',
  SECTION_UP_TO_NINE: 'Счет до 9',
  SECTION_MIRROR: 'Зеркальные числа',
  SECTION_TEN: 'Круглые числа',

  DIVISION_TABLE: 'Таблица деления',
  DIVISION_REMAINDER: 'Деление с остатком',
  DIVISION_SIMPLE: 'Простое деление 4D/2D',
  DIVISION_ONE_ITERATE: 'Деление с 1 перебором 4D/2D',
  DIVISION_MORE_ITERATE: 'Деление с 2 переборами и более 4D/2D',
  DIVISION_SAME: 'Деление с одинаковыми первыми числами 4D/2D',
  DIVISION_BY_ONE: 'Деление с числами на 1 4D/2D',
  DIVISION_RANDOM: 'Произвольное деление',
  DIVISION_FIRST: 'Делимое',
  DIVISION_SECOND: 'Делитель',

  MULTIPLICATION_TABLE: 'Таблица умножения',
  MULTIPLICATION_SIMPLE: 'Простое умножение',
  MULTIPLICATION_RANDOM: 'Произвольное умножение',
  MULTIPLICATION_ONE_ITERATE: 'Умножение с 0',
  MULTIPLICATION_MORE_ITERATE: 'Умножение с 5',
  MULTIPLICATION_FIRST: 'Множитель 1',
  MULTIPLICATION_SECOND: 'Множитель 2',
  MULTIPLIER: 'Множитель',
  DECIMAL_MODE: 'Десятичные',
  SQRT: 'Квадратный корень',
  CURT: 'Кубический корень',
  SQUARE: 'Число в квадрате',
  CUBE: 'Число в кубе',
  ANSWER_DISCHARGE: 'Разряд ответа',
  ANSWER_DISCHARGE_TYPE: 'Ответ',
  RANDOM_TYPE: 'Случайный',
  SMALL_FISH: 'Минимальный разряд ответа (маленькая рыбка)',
  BIG_FISH: 'Максимальный разряд ответа (большая рыбка)',

  SMALL_MOUSE: 'Минимальный разряд ответа (маленькая мышка)',
  BIG_MOUSE: 'Максимальный разряд ответа (большая мышка)',
  ROTATION_TYPE: 'Чередование',
  RANDOM_ROTATION: 'Случайное',
  SINGLE_ROTATION: 'Одинарное',
  DOUBLE_ROTATION: 'Двойное',

  NUMERALS: 'Цифра(ы)',
  RIGHT_ANSWERS: 'Правильные ответы',
  RIGHT_ANSWER: 'Правильный ответ ',
  WRONG_ANSWERS: 'Ошибочные ответы',
  SIMULATOR_TYPE: 'Тип тренажера',
  SIMULATOR_SETTINGS: 'Параметры тренажеров',
  PARAMS: 'Параметры',
  NUMBER_OF_WINDOWS: 'Кол-во окон',
  NUMBER_OF_EXAMPLES: 'Кол-во примеров',
  count: 'Кол-во примеров',
  COMPLETION_TIME: 'Время ',
  TIME_LIMIT_VALUE: 'Время выполнения (мин:сек)',
  TIME_LIMIT_MODE: 'Режим времени',
  LIMITED_TIME: 'Ограниченное время',
  UNLIMITED_TIME: 'Без ограничения времени',
  RESTART: 'Заново',

  CEIL: 'Целое',
  REMAINDER: 'Остаток',

  SECOND: 'сек',
  TERMS: 'Слагаемых',

  base: 'Базис',
  base_side: 'Стороны базиса',
  digits_mode: 'Режим количества разрядов',

  DIGITS_MODE_MIN_RANGE: 'Минимальный разряд ответа',
  DIGITS_MODE_MAX_RANGE: 'Максимальный разряд ответа',
  DIGITS_MODE_RANDOM_RANGE: 'Случайный',

  BASE_SIDE_LESS: 'Оба меньше базиса',
  BASE_SIDE_MORE: 'Оба больше базиса',
  BASE_SIDE_DIFF: 'По разные стороны базиса',

  NOT_EXCEED_50: 'без перехода',
  NOT_EXCEED_100: 'за 50',
  EXCEED_100: 'за 100',

  DICTATION_AMOUNT: 'Количество примеров',
  DICTATION_PERIOD: 'Пауза между примерами',
  DICTATION_START: 'Начать диктант',
  DICTATION_STOP: 'Остановить диктант',
  DICTATION_NEXT: 'Продолжить диктант',

  SCHOOL_NAME: 'Название',
  SCHOOL_CITY: 'Город',
  SCHOOL_ADDRESS: 'Адрес',
  SCHOOL_METRO_STATION: 'Станция метро',
  SCHOOL_FULL_NAME_OF_HEAD: 'ФИО руководителя',
  PHONE: 'Телефон',
  PREVIOUS_PAGE: 'Предыдущая страница',
  NEXT_PAGE: 'Следующая страница',
  EDIT_DATA: 'Редактировать данные',
  ADD_RECORD: 'Добавить запись',
  DELETE_RECORD: 'Удалить запись',
  RESTORE_USER: 'Восстановить пользоваеля',
  RECORD_PER_PAGE: 'Строк на странице',
  PASSWORD: 'Пароль',
  DATE_REGISTRATED: 'Дата регистрации',
  DATE_BEGINING: 'Дата начала',
  DATE_ENDING: 'Дата завершения',
  DATE_CREATING: 'Дата создания',
  DATE_DELETED: 'Дата удаления',
  BY_DAYS: 'По дням',
  CREATED: 'Создано',

  SELECTED: 'Выбор...',
  NOT_RECORD: 'Нет записей',
  NOT_FOUND_CATEGORIES_FOR_OLIMPIC: 'Не найдено категорий под ваш год рождения',
  DIRECTORY_STUDENTS_TITLE:
    'Тут все ученики, которые на платформе зарегистрировались самостоятельно, в том числе и по реферальным ссылкам',
  ICON: 'Иконка',

  user_guide: 'Руководство',
  user_online: 'Онлайн: {count}',
  _users: 'пользователей',
  _online: 'онлайн',

  RESET: 'Сбросить',
  CHOOSE_THEME: 'Выбор оформления',
  ABACUS_DESCRIPTION:
    'Используйте виртуальный абакус и доску для пояснения новой темы.',
  MARKS: 'Как поставить метку на абакус',
  ABACUS: 'Абакус',
  DESK: 'Доска',

  GROUPS: 'Группа(ы)',
  EMAIL_STUDENT: 'Email ученика',
  NAME_SURNAME_STUDENT: 'Имя Фамилия ученика',
  AGE: 'Возраст',
  EMAIL_PARENT: 'Email родителя',
  NAME_SURNAME_PARENT: 'Имя Фамилия родителя',
  ACTIVE: 'Активен',
  SEND_EMAIL_TO_STUDENT: 'Отправить логин и пароль пользователя на этот email',
  DATEBIRTH: 'Дата рождения',
  YES: 'Да',
  NO: 'Нет',
  SEARCH: 'Поиск',

  SEARCH_STUDENTS: 'Поиск по ученикам',
  SEARCH_DATE: 'Поиск по дате',
  REPEAT_PASSWORD: 'Повторите пароль',
  I_AGREE:
    'Я согласен с Политикой конфиденциальности и Правилами использования',

  WITH_ANSWER: 'Добавить ответы в примеры',
  WITH_ANSWER_SEPARATE_SHEET: 'Ответы на отдельный лист',
  TO_PRINT: 'Распечатать',
  CERTIFICATION_PAGE_TITLE_SAMA:
    'SAMA GLOBAL ABACUS & MENTAL ARITHMETIC EXAMINATION',
  CERTIFICATION_PAGE_TITLE_PAMA:
    'PAMA GLOBAL ABACUS & MENTAL ARITHMETIC EXAMINATION',
  CERTIFICATION_PAGE_TITLE_UAMAP: 'Экзамен по ментальной арифметике UAMAP',
  CERTIFICATION_LEVEL_TIME: 'ВРЕМЯ',
  MIN: 'МИН',
  MENTAL_ARITHMETIC: 'Счет ментально',
  ARITHMETIC_FOR_CHILDREN: 'Уровни для детей',
  ARITHMETIC_FOR_TEACHER: 'Уровни для педагогов',
  FOR_CHILDREN: 'Для детей',
  FOR_TEACHER: 'Для педагогов',
  ABACUS_ARITHMETIC: 'Счет на абакусе',
  MENTAL_ARITHMETIC_ADD: 'СЧЕТ МЕНТАЛЬНО (+,-)',
  ABACUS_ARITHMETIC_ADD: 'СЧЕТ НА АБАКУСЕ (+,-)',
  MENTAL_ARITHMETIC_MULTIPLICATION: 'СЧЕТ МЕНТАЛЬНО (*)',
  ABACUS_ARITHMETIC_MULTIPLICATION: 'СЧЕТ НА АБАКУСЕ (*)',
  MENTAL_ARITHMETIC_DIVISION: 'СЧЕТ МЕНТАЛЬНО (÷)',
  ABACUS_ARITHMETIC_DIVISION: 'СЧЕТ НА АБАКУСЕ (÷)',
  ADD: 'СЛОЖЕНИЕ',
  CARD: 'ОБРАЗ ЧИСЛА',
  FIVE: 'СОСТАВ ЧИСЛА 5',
  TEN: 'Состав числа 10',
  NEXT_LEVEL: 'Следующее задание',
  NEXT_TEST: 'Пройти другой тест',
  RESULT: 'РЕЗУЛЬТАТ',
  SCORE: 'Счет',
  LEVEL: 'Уровень',
  LEVEL_1: 'Уровень 1',
  LEVEL_2: 'Уровень 2',
  LEVEL_3: 'Уровень 3',
  LEVEL_4: 'Уровень 4',
  LEVEL_5: 'Уровень 5',
  LEVEL_6: 'Уровень 6',
  LEVEL_7: 'Уровень 7',
  LEVEL_7_A: 'Уровень 7 A',
  LEVEL_7_B: 'Уровень 7 B',
  LEVEL_8: 'Уровень 8',
  LEVEL_8_A: 'Уровень 8 A',
  LEVEL_8_B: 'Уровень 8 B',
  LEVEL_9: 'Уровень 9',
  LEVEL_9_A: 'Уровень 9 A',
  LEVEL_9_B: 'Уровень 9 B',
  LEVEL_10: 'Уровень 10',
  LEVEL_10_A: 'Уровень 10 A',
  LEVEL_10_B: 'Уровень 10 B',
  LEVEL_11: 'Уровень 11',
  LEVEL_12: 'Уровень 12',
  LEVEL_13: 'Уровень 13',
  LINK_BY_VIDEO: 'Ссылка на Диск',
  SAVE_RESULT_BY_TEST: 'Сохранить результаты экзамена',
  STARTING_EXAM: 'ПРИСТУПИТЬ К ВЫПОЛНЕНИЮ ЭКЗАМЕНА',
  ABACUS_TYPE: 'Абакус,',
  MENTAL_TYPE: 'Ментальное',
  ADD_TYPE: 'Сложение и вычитание (+, -)',
  MULTIPLICATION_TYPE: 'Умножение (*)',
  MULTIPLICATION_TABLE_TYPE: 'Таблица умножения (*)',
  MULTIDIVISION_TYPE: 'Таблица умножения и деления',
  MULTIDIV_TYPE: 'Умножение и деление',
  DIVISION_TABLE_TYPE: 'Таблица деления (÷)',
  DIVISION_TYPE: 'Деление (÷)',
  TIE_TYPE: 'Тай-брикер',

  PRINT_CERTIFICATION: 'Распечатать сертификат',
  CREATE_CERTIFICATION: 'Создать сертификат',
  EXAM_CHECKING: 'Экзамен находится на проверке',
  EXAM_STATUS_NOT_FOUND: 'Статус экзамена не определен',
  EXAM_WAITING_RUN:
    'Экзамен создан и ожидает выполнения в личном кабинете ученика',
  SET_CODE: 'Введите ваш код',
  CHECK_CODE: 'Проверить',
  CERTIFICATION_NOT_FOUND:
    'Сертификат с таким кодом не найден, попробуйте еще раз.',
  SCHEDULE_TITLE: 'Расписание',
  PROFILE_TITLE: 'Профиль',
  NEWS_TITLE: 'Новости',
  NEWS_EDIT_TITLE: 'Лента',
  NEWS_FEED_TITLE: 'Управление',
  DELEGATES: 'Представители',
  TEAM_MODE_TITLE: 'Командный режим',
  OLIMPIC_TITLE: 'Олимпиада',
  FOR_PARENTS_TITLE: 'Для родителей',
  REGISTER: 'Зарегистрировать',
  HOMEWORK_STATUS: 'Статус',
  COMPLETED: 'Выполнено',
  OVERCOMPLETE: 'Перевыполнено',
  UNCOMPLETED: 'Не выполнено',
  USER: 'Пользователь',
  CERTIFICAT: 'Сертификат',
  CATEGORY: 'Категория',
  mark: 'баллов',

  'country.AZ': 'Азербайджан',
  'country.AM': 'Армения',
  'country.BY': 'Беларусь',
  'country.BE': 'Бельгия',
  'country.BG': 'Болгария',
  'country.GB': 'Великобритания',
  'country.DE': 'Германия',
  'country.IL': 'Израиль',
  'country.IN': 'Индия',
  'country.IT': 'Италия',
  'country.KZ': 'Казахстан',
  'country.CY': 'Кипр',
  'country.KG': 'Кыргызстан',
  'country.KR': 'Южная Корея',
  'country.LB': 'Ливан',
  'country.LT': 'Литва',
  'country.LV': 'Латвия',
  'country.RU': 'Россия',
  'country.RO': 'Румыния',
  'country.US': 'США',
  'country.SA': 'Саудовская Аравия',
  'country.TJ': 'Таджикистан',
  'country.TH': 'Таиланд',
  'country.TQ': 'Турция',
  'country.UZ': 'Узбекистан',
  'country.UA': 'Украина',
  'country.FR': 'Франция',
  'country.CH': 'Швейцария',
  'country.SE': 'Швеция',
  'country.EE': 'Эстония',
  'country.CN': 'Китай',
  'country.TW': 'Тайвань',
  'country.CA': 'Канада',
  'country.MY': 'Малайзия',
  'country.HK': 'Гонконг',
  'country.VN': 'Вьетнам',
  'country.PS': 'Палестина',
  'country.EG': 'Египет',
  'country.JO': 'Иордания',
  'country.IQ': 'Ирак',
  'country.IR': 'Иран',
  'country.AE': 'ОАЭ',
  'country.AU': 'Австралия',
  'country.ZA': 'Южная Африка',

  COUNTRY: 'Страна',
  EXAM_RESULT: 'Результат экзамена',
  GENERATE_XLSX: 'Сгенерировать XLSX',
  GENERATE_SAMA_XLSX: 'Сгенерировать SAMA XLSX',
  GENERATE_PAMA_XLSX: 'Сгенерировать PAMA XLSX',
  SAVE_TO_COMPUTER: 'Сохранить на компьютер',
  CHANGE_RANKS: 'Изменить выбранные',
  SET_OLIMPIC_RANKS: 'Выберите место, которое хотите назначить участникам',
  STARS: 'Звёзды',
  STARS_FOR_HOMEWORK: 'Количество звезд за домашнее задание',
  RANK: 'Звание',
  RANK_1: 'Новичок',
  RANK_2: 'Юниор',
  RANK_3: 'Счетовод',
  RANK_4: 'Знаток',
  RANK_5: 'Эрудит',
  RANK_6: 'Самородок',
  RANK_7: 'Всезнайка',
  RANK_8: 'Уникум',
  RANK_9: 'Вундеркинд',
  RANK_10: 'Гений',
  PLACE_IN_RATING: 'Место в рейтинге',
  NO_RATE: 'Не участвует',
  FEATHERS: 'Перья',
  PROGRESS_TO_NEXT_RANK: 'Прогресс до следующего звания',
  SUMM: 'Сумма',
  PURPOSE_OF_PAYMENT: 'Назначение платежа',
  ENTER_PASSWORD: 'Введите пароль',
  CONFIRM_IS_PARENT:
    'Для того, чтобы подтвердить, что Вы и вправду родитель, введите действующий пароль от данного аккаунта',
  BALANCE: 'Баланс',
  UCOINS1: 'юкоин',
  UCOINS2: 'юкоина',
  UCOINS5: 'юкоинов',
  ACCESS_TO_PLATFORM: 'Доступ к платформе',
  INFINITY_ACCESS_TO_PLATFORM: 'Доступ к платформе неограничен',
  WAIT_PAY:
    'Ожидает оплаты. На другой вкладке браузера открылась страница онлайн-кассы',
  PAY: 'Оплатить',
  FREE: 'Бесплатно',
  CERT_EXAM: 'Экзамен на сертификат',
  CERT_EXAMS: 'Экзамен на сертификацию',
  OLIMPIC_PARTICIPATION: 'Участие в олимпиаде',
  OLIMPIC_PARTICIPATIONS: 'Участие в олимпиадах',
  CERT_SAMA_GLOBAL_EXAM: 'Количество купленных экзаменов SAMA GLOBAL',
  CERT_PAMA_GLOBAL_EXAM: 'Количество купленных экзаменов PAMA GLOBAL',
  CERT_UAMAP_EXAM: 'Количество купленных экзаменов UAMAP',
  OLIMPIC_ONLINE_PARTICIPATION: 'Количество участий в онлайн олимпиадах',
  OLIMPIC_OFFLINE_PARTICIPATION: 'Количество участий в очных олимпиадах',
  OLIMPIC_SAMA_PARTICIPATION: 'Количество участий в PAMA олимпиадах',
  REGISTER_STUDENTS: 'Пакет доступа для учеников',
  PURCHASED: 'Приобретено',
  DAYS_ON_PLATFORM: 'Дней на платформе',
  DAYS_LEFT: 'Осталось дней',
  SUSPENDED: 'Приостановлен',
  UNTIL: 'До',
  PROLONG: 'Продлить',
  TOP_UP_ACCOUNT: 'Пополнить счет',
  SAVE_CHANGES: 'Сохранить изменения',
  MOBILE_PHONE: 'Мобильный телефон',
  REFERALS_TITLE: 'Реферальная система',
  MANAGEMENT: 'Управление',
  ABOUT_GAMIFICATION: 'О геймификации',
  UCOINS_TITLE: 'Юкоины',
  STATISTICS: 'Статистика',
  THEMATIC: 'Тематика',
  CONTENT: 'Содержимое',
  BACK: 'Назад',
  ERROR_INCORRECT: 'К сожалению, введенный пароль не верен',
  DEADLINE_ERROR:
    'Укажите, до какого срока будут назначаться ежедневные задания, но не более месяца',
  CONFIRM_PAYMENT:
    'После подтверждения средства с баланса спишутся в пользу выбранной услуги',
  PRODUCTS_TITLE: 'Цены',
  PRODUCTS_LEARNER: 'Товары учеников',
  PRODUCTS_TEACHER: 'Товары педагогов и школ',
  PRODUCTS_SCHOOL: 'Товары школ',
  PRODUCTS_TEACHER_ASSOC: 'Товары педагогов, представителей ассоциации',
  PRODUCTS_SCHOOL_ASSOC: 'Товары школ, представителей ассоциации',
  PRODUCTS_ASSOC: 'Товары для представителя ассоциации',
  CONFIRM_PAY_PRODUCT:
    'Уверены, что хотите приобрести "{product}" за {price} рублей?',
  CONFIRM_PRODUCT: 'С баланса будет списано {price} юкоинов для оплаты {name}.',
  CONFIRM_PRODUCT_SELF: 'С баланса будет списано {price} юкоинов.',
  CONFIRM_PAYMENT_PACKAGE:
    'Уверены, что хотите оплатить из приобретенного ПАКЕТА ДОСТУПОВ для ученика {name}?',
  CONFIRM_BUY_PACK:
    'Уверены, что хотите приобрести пакеты доступов для {name}?',
  CONFIRM_PACK:
    'Будет приобретен пакет доступа для {count} учеников за {price} юкоинов',
  PACKAGES_AMOUNT: 'Пакеты доступов',
  PAYMENT_LIMIT_WARNING:
    'Для зарубежных пользователей оплата возможна только по картам МИР и БЕЛКАРТ',
  PURCHASE_ERROR: 'Произошла ошибка',
  PURCHASE_NOT_ENOUGH: 'Недостаточно средств',
  PURCHASE_SUCCESS: 'Покупка успешно завершена',
  NOT_ENOUGH_PACK: 'Недостаточно доступов в пакете',
  HAVE_ONLINE_OLIMPIC: 'У пользователя уже есть доступ к Онлайн олимпиаде',
  HAVE_OFFLINE_OLIMPIC: 'У пользователя уже есть доступ к Очной олимпиаде',
  HAVE_MAINTAINERS:
    'У пользователя уже есть билет сопровождающего на Очную олимпиаду',
  NOT_REGISTERED_OFFLINE_OLIMPIC: 'Вы не зарегистрировались на Очную олимпиаду',
  OK: 'Хорошо',
  CONFIRM: 'Подтвердить',
  CONTINUE: 'Продолжить',
  CANCEL: 'Отменить',
  REFUSE: 'Отказаться',
  PURCHASES: 'Покупки',
  currency: 'юкоинов',
  currency_short: 'ю.',
  CURRENCY_EQUAL: '1 рубль = 1 юкоин',
  REGISTER_STUDENT_ISUFFICIENT_FUNDS:
    'Для того, чтобы зарегистрировать ученика самостоятельно, купите подходящий пакет с доступом в разделе покупки',
  ACCESS_ISUFFICIENT_FUNDS:
    'Доступ к платформе закончился. Оплатите его в разделе Для родителей/Управление',
  ACCESS_NO_DEMO_FUNDS:
    'Оплатите доступ к платформе в разделе Для родителей/Управление',
  ACCESS_ISUFFICIENT_FUNDS_TEACHER:
    'Нужно иметь хотя бы 1 ученика с оплаченным доступом. Оплатить его можете самостоятельно',
  ACCESS_NO_DEMO_FUNDS_TEACHER:
    'Нужно иметь хотя бы 1 ученика с оплаченным доступом. Оплатить его можете самостоятельно',
  SAMA_ACCESS_MESSAGE:
    'К сожалению, сейчас вы не можете участвовать в олимпиаде. Пожалуйста, приобретите доступ к олимпиаде SAMA GLOBAL в разделе ',
  PAMA_ACCESS_MESSAGE:
    'К сожалению, сейчас вы не можете участвовать в олимпиаде. Пожалуйста, приобретите доступ к олимпиаде PAMA GLOBAL в разделе ',
  NO_ACCESS: 'Этот раздел недоступен',
  ACCESS_NO_OLIMPIC: 'Нужна оплата участия в олимпиаде',
  ENTER_AMOUNT: 'Введите сумму, на которую хотите пополнить аккаунт',
  NOT_SELECTED: 'Не выбрано',
  MENTAL_ARITHMETIC_TITLE: 'Ментальная арифметика',
  ROOM_SHORT: 'Каб.',
  TIME: 'время',
  min: 'мин.',
  EACH_Q: 'верный ответ',
  marks: 'баллов',
  DATE: 'Дата',
  DATE_FORMAT: 'ДД.ММ.ГГГГ',
  SAVE: 'Сохранить',
  SAVE_LINK: 'Сохранить ссылку',
  link: 'Ссылка',
  ADD_LESSON: 'Добавить занятие',
  RECEIVE_BONUSES:
    'Получайте бонусы за приглашение новых учеников или преподавателей',
  REFERAL_LINK_FOR_STUDENTS: 'Реферальная ссылка для учеников',
  REFERAL_LINK_FOR_TEACHERS: 'Реферальная ссылка для преподавателей',
  COPY: 'Копировать',
  ABOUT_REFERAL_ADMIN: 'О реферальной системе',

  ACHIEVEMENTS: 'Достижения',
  NEW: 'Новое',
  NEW_OR_COMPLETED: 'Новое / Выполненное',
  TODAY_OR_ALL: 'На сегодня / Все',
  ALL_ACHIEVEMENTS: 'Все достижения',
  HERE_ALL_ACHIEVEMENTS:
    'Здесь Вы можете просмотреть все достижения, которые уже получили или еще нет.',
  CLEAR: 'Понятно',
  WORKS: 'Задания',
  HOME_WORKS: 'Домашние задания',
  ALL_HOME_WORKS: 'Все задания',
  HOME_WORKS_EMPTY: 'Нет домашних заданий',
  ADD_TRAIN: 'Добавьте тренажер сюда',
  COMPLETE: 'Выполнить',
  COMPLETE_OVER: 'Выполнить до',
  FOR_RECEIVE_NEW_ACHIEVEMENTS:
    'Чтобы получить новое, копи опыт и зарабатывай достижения.',
  EXPERIENCE_GRADING: 'Градация опыта',
  EXPERIENCE_REQUIRED: 'Необходимый опыт',
  CONFIRM_RESET_FEATHERS:
    'Вы уверены, что хотите обнулить перья всем участникам?',
  FOR_RESET_FEATHERS: 'Нажмите, чтобы обнулить перья всем пользователям',
  RESET_FEATHERS: 'Обнулить перья',
  CHAMPIONS_CORNER: 'Уголок Чемпионов',
  PHOTO: 'Фото',
  OPEN_ALL_OLIMP_CHAMPIONS: 'Посмотреть все олимпиады',
  RATING: 'Рейтинг',
  TEACHER_RATING: 'Рейтинг педагогов',
  STUDENT_RATING: 'Рейтинг учеников',
  PLACE: 'Место',
  place1: '1-ое место',
  place2: '2-ое место',
  place3: '3-е место',
  PLACE_EN: 'place',
  PLACE_LABEL: 'Место (цифрой. 0 - если чемпион)',
  OPEN_FULL_LIST: 'Открыть полный список',
  USERS_LIST: 'Список пользователей',
  YOUR_PLACE_IN_RATING: 'Сейчас твое место в рейтинге',
  FOR_UP_IN_RATING_TEACHER:
    'Чтобы подняться выше получай достижения, проводи занятия и приглашай на платформу новых учеников и педагогов',
  FOR_UP_IN_RATING_STUDENT:
    'Чтобы подняться выше решай больше примеров и зарабатывай перья с достижений',
  STUDENT_NAME: 'Имя ученика',
  TEACHER_NAME: 'Имя педагога',
  POINTS: 'Баллы',
  TEACHER_ADD_STUDENT:
    'добавил вашего ребенка в список своих учеников. Подтвердить действие?',
  SUBSCRIBE_1_MONTH: 'Подписка на 1 месяц',
  FROM_PACKET: 'из пакета',
  SUBSCRIBE_1_MONTH_PACKET: 'Подписка на 1 месяц из пакета',
  SUBSCRIBE_6_MONTH: 'Подписка на 6 месяцев',
  SUBSCRIBE_12_MONTH: 'Подписка на год',
  SAMA_CERT: 'Сертификация SAMA GLOBAL',
  PAMA_CERT: 'Сертификация PAMA GLOBAL',
  UAMAP_CERT: 'Сертификация UAMAP для ученика',
  UAMAP_CERT_TEACHER: 'Сертификация UAMAP для преподавателя',
  SAMA_CERT_SHORT: 'SAMA GLOBAL',
  PAMA_CERT_SHORT: 'PAMA GLOBAL',
  UAMAP_CERT_SHORT: 'UAMAP для ученика',
  UAMAP_CERT_TEACHER_SHORT: 'UAMAP для преподавателя',
  MONTH: 'месяц',
  MONTHS: 'месяцев',
  STUDENT_GENITIVE: 'ученика',
  STUDENTS_GENITIVE: 'учеников',
  SELECT: 'Выберите',
  SELECT_PRODUCT: 'Выберите продукт',
  SELECT_USER: 'Выберите пользователя',
  SELECT_LEARNER: 'Выбор ученика',
  SELECT_STUDENT: 'Выбор ученика',
  SELECT_TEACHER: 'Выбор учителя',
  SELECT_STUDENTS_AMOUNT: 'Выберите кол-во участников',

  // Ucoins
  // Transactions

  ACCESS: 'Покупка доступа к платформе на',
  REPLENISHMENT: 'Пополнение',
  PACKET: 'Покупка пакета доступа для',
  ACCESS_FROM_PACKET: ' Покупка доступа к платформе из пакета',
  SAMA_PAYMENT: 'Покупка экзамена на сертификат SAMA GLOBAL',
  PAMA_PAYMENT: 'Покупка экзамена на сертификат PAMA GLOBAL',
  UAMAP_PAYMENT: 'Покупка экзамена на сертификат UAMAP',
  ONLINE_OLIMPIC_PAYMENT: 'Покупка участия в онлайн олимпиаде',
  OFFLINE_OLIMPIC_PAYMENT: 'Покупка участия в оффлайн олимпиаде',
  SAMA_OLIMPIC_PAYMENT: 'Покупка участия в SAMA GLOBAL олимпиаде',
  PAMA_OLIMPIC_PAYMENT: 'Покупка участия в PAMA GLOBAL олимпиаде',
  MAINTAINER_PAYMENT: 'Сопровождающий к олимпиаде',

  GAMIFICATION_1:
    'Геймификация - это внедрение игровых механик в неигровые сферы. Данная система геймификации направлена на повышение уровня вовлеченности и заинтересованности пользователей. Рейтинг строится на основании успехов преподавателя и его учеников. Экзамены, приведенные ученики и количество занятий повышают вас в рейтинге.',
  GAMIFICATION_2:
    'Достижения преподаватели могут получить, если будут выполнять определенные задачи на платформе.',
  GAMIFICATION_3:
    'Геймификация - это про игры. Здесь ты сможешь играть и развиваться. На этой вкладке рассказано про все игровые механики, которые есть на платформе. Перья - это баллы, по которым формируется рейтинг учеников. Рейтинг - это список всех учащихся, который строится на основе успехов каждого. Звания - это ступеньки, по которым ты поднимаешься, благодаря полученным ачивкам. Достижения - это награда, которую можно получить за выполнение какого-либо действия.',
  GAMIFICATION_4: 'Теперь обо всем поподробнее',
  GAMIFICATION_5:
    'Рейтинг обновляется каждые 3 месяца. Таким образом лучшие ученики и преподаватели смогут выигрывать ценные призы.',
  GAMIFICATION_6:
    'Рейтинг строится на количестве заработанных перьев для учеников и рейтинговых баллов для преподавателей. Чем больше баллов и перьев - тем выше место в рейтинге. Те, кто оказались на вершине рейтинга  получат крутые физические и виртуальные призы.',
  GAMIFICATION_7:
    'Достижения способствуют формированию рейтинга среди преподавателей.',
  GAMIFICATION_8:
    'Чтобы получить как можно больше достижений и рейтинговых баллов, необходимо: сдавать экзамены, проводить занятия и взаимодействовать с платформой.',
  GAMIFICATION_9:
    'Также важно мотивировать своих учеников погружаться в мир ментальной математики с головой.',
  GAMIFICATION_10:
    'Не забывайте об этом и вас, как и учеников, ждет вершина рейтинга!',
  GAMIFICATION_11:
    'Достижения - это забавные значки, которые ты можешь получить, когда занимаешься на портале. Каждое достижение приносит тебе определенное количество опыта и перьев.',
  GAMIFICATION_12:
    'Ачивки приобретают цвет, когда ты их получаешь, а пока они будут черно-белыми. Но уже сейчас ты можешь увидеть, сколько перьев и опыта получишь за то или иное достижение.',
  GAMIFICATION_13:
    'Рейтинговые баллы - это баллы, которые можно накопить выполняя ключевые действия на платформе или получая достижения.',
  GAMIFICATION_14:
    'Действия могут включать в себя проведенные занятия, заданные домашние работы и приглашение пользователей на платформу по реферальной ссылке.',
  GAMIFICATION_15:
    'Перья - это баллы, по которым формируется рейтинг учеников. Перья копятся через достижения и решение примеров по особой формуле. Чем сложнее примеры - тем больше перьев. Каждые 3 месяца данный показатель обнуляется, чтобы мы смогли определить новых победителей в рейтинге.',
  GAMIFICATION_16:
    'Звания на платформе - это ступеньки, по которым ты поднимаешься, благодаря выполненным заданиям и полученным достижениям. Чем больше ты получишь опыта за достижения, тем круче звание тебе достанется.',
  GAMIFICATION_17:
    'За каждый пройденный уровень ты получишь не только новое звание, но и уникальную рамку для аватара в профиле. Самым высоким званием считается &quot;Гений&quot;, его можно получить достигнув 10 уровня.',
  GAMIFICATION_18:
    'Говорят до него доходят не все... Если дойдешь, можешь считать, что прошел портал, как игру.',
  GAMIFICATION_19:
    'Звезды - это оценка преподавателя за выполненные домашние задания.',
  GAMIFICATION_20:
    'Чем лучше стараешься, тем выше шансы получить больше звезд. Будь лучшим учеником своего педагога!',
  REFERAL_ADMIN: 'Реферальная система',
  MOVE_UCOINS_TO_BALANCE: 'Перевести юкоины на баланс',
  INVITED_STUDENTS: 'Приведено учеников',
  ACTIVE_STUDENTS: 'Активные ученики с доступом к платформе',
  INVITED_TEACHERS: 'Приведено преподавателей',
  EARNED_UCOINS: 'Заработано юкоинов',
  REFERAL_TEXT_1:
    'При помощи реферальной системы Вы можете копить Юкоины бесплатно.',
  REFERAL_TEXT_2:
    'Для этого, необходимо, чтобы по вашей ссылке регистрировалось и оплачивало подписку как можно больше новых учеников.',
  REFERAL_TEXT_3: 'За каждого ученика Вы будете получать по 25 Юкоинов',
  REFERAL_TEXT_4:
    'При помощи реферальной системы Вы можете копить Юкоины бесплатно. Для этого, необходимо, чтобы по вашей ссылке регистрировалось как можно больше учеников и педагогов.',
  REFERAL_TEXT_4_S:
    'При помощи реферальной системы Вы можете копить Юкоины бесплатно. Для этого, необходимо, чтобы по Вашей ссылке или по ссылке Ваших педагогов регистрировалось как можно больше учеников и педагогов.',
  REFERAL_TEXT_5:
    'За первую оплату платформы приведенным Вами учеников Вы получите - 25 Юкоинов',
  REFERAL_TEXT_5_S:
    'За первую оплату платформы приведенными Вами или Вашими педагогами учеников получите - 25 Юкоинов',
  REFERAL_TEXT_6:
    'За первую оплату платформы ученика, приведенного Вами преподавателя - 50 Юкоинов',
  REFERAL_TEXT_6_S:
    'За первую оплату платформы ученика, приведенного Вами или Вашими педагогами преподавателя - 50 Юкоинов',
  REFERAL_TEXT_7:
    'За любое пополнение счета приведенного Вами ученика - 5% от суммы пополнения',
  REFERAL_TEXT_7_S:
    'За любое пополнение счета приведенного Вами или Вашими педагогами ученика - 2% от суммы пополнения "',
  PERSONAL_RATING: 'Личный рейтинг',
  PUBLIC_RATING: 'Общий рейтинг',
  RATING_UPDATE: 'Рейтинг обновляется каждый день в 00:00 (Мск)',
  SCORES_TITLE: 'Рейтинговые баллы',
  RESULTS: 'Результаты',
  RESULTS_NOTICE:
    'Место могло быть понижено из-за отсутствия видео или участия победителя прошлых олимпиад в той же категории без ее повышения',
  PARTICIPATE: 'Участвовать',
  PARTICIPATE_OFFLINE: 'Участвовать в Очной Олимпиаде',
  OFFLINE_OLIMPIC_PARTICIPATE_NOTICE:
    'А теперь, заполните все поля и нажмите "Учаcтвовать", чтобы зарегистрироваться на олимпиаду',
  OLIMPIC_REGLAMENT_NOTICE: 'Внимательно ознакомьтесь с регламентом олимпиады!',
  OLIMPIC_LINK_REQUIRED_NOTIFY:
    ' Видеоссылка обязательна, иначе призовое место будет понижено! Убедитесь, что доступ к видео открыт. Прикрепить ссылку доступно и после олимпиады до проверки результатов',
  OLIMPIC_START_NOTIFY:
    ' Желаем вам удачи и победы! После нажатия кнопки “Начать олимпиаду” вы не сможете вернyться назад, у вас будет только 1 попытка. Всю олимпиаду от начала до конца необходимо снимать. Видео загрузить на любое облачное хранилище и прикрепить ссылку.',
  OLIMPIC_PRE_RUN_NOTIFY:
    'Подтвердите свою готовность и дождитесь окончания таймера подготовки',
  IVE_READ_RULES:
    'Я внимательно прочитал и согласен с вышеперечисленными правилами',
  PREPARED_CAMERA:
    'Я готов снимать процесс прохождения олимпиады на видеокамеру, и согласен предоставить видео на проверку',
  OLIMPIC_TECHNICAL_REQUIREMENT:
    'Проверьте качество интернет соединения. Переходы по вкладкам, перезапуск и обновление страницы ЗАПРЕЩЕНЫ, и ваше участие будет завершено!',
  IM_READY:
    'Я готов приступить к прохождению олимпиады. У меня нет проблем с соединением и я не собираюсь покидать страницу до сохранения результата олимпиады',
  GET_READY: 'Приготовьтесь!',
  CURRENT_PING: 'Текущее качество соединения',
  SEC: 'сек.',
  GOOD: 'Хорошо',
  NORMAL: 'Нормально',
  WORST: 'Ужасно',
  DISCONNECTED: 'Отключено',
  OLIMPIC_TYPE: 'Тип олимпиады',
  olimpic_files: 'Загрузите файлы, и проставьте нужные ссылки в поля',
  ABOUT_OLIMPIC: 'Олимпиада',
  SAMA_OLIMPIC: 'Sama Global',
  PAMA_OLIMPIC: 'Pama Global',
  PAY_OFFLINE_SELF: 'Купить билет себе',
  PAY_OTHER_OFFLINE: 'Купить билет другим',
  OFFLINE_OLIMPIC: 'Очная',
  OFFLINE_OLIMPIC_FOR_STUDENT: 'Очная для ученика',
  OFFLINE_OLIMPIC_FOR_TEACHER: 'Очная для педагога',
  ONLINE: 'Онлайн',
  ONLINE_LEARNER: 'Онлайн для ученика',
  ONLINE_TEACHER: 'Онлайн для педагога',
  OLIMPIC_REQUIRE_PAYMENT: 'Необходима оплата участия в олимпиаде',
  ACCESS_REQUIRE_PAYMENT: 'Необходима оплата доступа к платформе',
  REQUIRE_FIELDS: 'Необходимо заполнить все поля',
  OLIMPIC_LIST: 'Список олимпиад',
  OLIMPIC_NOT_FOUND: 'Не найдена предстоящая олимпиада',
  WILL_PASS: 'пройдёт',
  CREATE: 'Добавить',
  OLIMPIC_TABLE_CREATE_TITLE: 'Создать олимпиаду',
  OLIMPIC_TABLE_EDIT_TITLE: 'Редактировать олимпиаду',
  OLIMPIC_TABLE_EDIT_PARTICIPANT: 'Редактировать участника олимпиады',
  OLIMPIC_SUCCESS_CREATE_MESSAGE: 'Олимпиада успешно создана',
  OLIMPIC_SUCCESS_EDIT_MESSAGE: 'Олимпиада успешно изменена',
  OLIMPIC_PRINT_TITLE: 'Печать заданий',
  TIME_BEGINING: 'Время начала',
  TIME_ENDING: 'Время завершения',
  OLIMPIC_SIMULATOR: 'Симулятор олимпиады',
  OLIMPIC_REGLAMENT: 'Регламент олимпиады',
  OLIMPIC_GROUPS_TASKS: 'Задания по группам',
  OLIMPIC_START_VIDEO_LINK: 'Ссылка на видео перед олимпиадой',
  OLIMPIC_END_VIDEO_LINK: 'Ссылка на видео после прохождения олимпиады',
  OLIMPIC_DIPLOMA_LINK_RU:
    'Ссылка на изображение для генерации дипломов (на русском)',
  OLIMPIC_DIPLOMA_LINK_EN:
    'Ссылка на изображение для генерации дипломов (на английском)',
  OLIMPIC_GRATITUDE_LINK_RU:
    'Ссылка на изображение для генерации благодарности (на русском)',
  OLIMPIC_GRATITUDE_LINK_EN:
    'Ссылка на изображение для генерации благодарности (на английском)',
  CUP_IMAGE_LINK: 'Ссылка на изображение кубка (Уголок Чемпионов)',
  OLIMPIC_SYLLABUS: 'Силлабус',
  OLIMPIC_RUN: 'Начать олимпиаду',
  SHOW_OFFLINE: 'Показать для Очной',
  SHOW_ONLINE: 'Показать для Онлайн',
  SHOW_SAMA: 'Показать для PAMA',
  RESET_OLIMPIC_PAYMENTS: 'Обнулить оплаты за олимпиады',
  RESET_FOR_ONLINE: 'Обнулить для ОНЛАЙН',
  RESET_FOR_OFFLINE: 'Обнулить для ОЧНОЙ',
  RESET_FOR_SAMA: 'Обнулить для PAMA',
  CONFIRM_RESET_ALL_OLIMPIC_PAYMENTS:
    'Вы уверены, что хотите удалить всем оплаты олимпиад?',
  OLIMPIC_PAY_PARTICIPATE: 'Оплатить участие в олимпиаде',
  OLIMPIC_PAY: 'Оплатить участие',
  OFFLINE_OLIMPIC_PAY_PARTICIPATE: 'Оплатить участие в очной олимпиаде',
  SAMA_OLIMPIC_PAY_PARTICIPATE: 'Оплатить участие в SAMA олимпиаде',
  PAMA_OLIMPIC_PAY_PARTICIPATE: 'Оплатить участие в PAMA олимпиаде',
  OLIMPIC_REGISTERED: 'Вы зарегистрировались на олимпиаду',
  OLIMPIC_STARTS: 'Она пройдёт',
  FROM: 'с',
  TO: 'по',
  OLIMPIC_COMPLETED: 'Олимпиада уже пройдена',
  DIPLOMS: 'Дипломы',
  DIPLOMA: 'Диплом',
  DIPLOM_FOR_CENTER: 'Диплом для центра',
  DIPLOM_FOR_TEACHER: 'Диплом для учителя',
  CHANGE_TEXT: 'Изменить текст',
  ENTER_TEXT: 'Введите текст',
  YEARS: 'лет',
  PAYMENT_PARAM_VALIDATION: 'Необходимо выбрать продукт',
  PAYMENT_PARAMS_VALIDATION: 'Необходимо выбрать продукт и ученика',
  EXAM_REQUIRE_PAYMENT: 'Необходима оплата для сдачи экзамена',
  OVERALL_SCORE: 'Общий балл',
  SCORE_O: 'Баллы',
  SCORE_MAX: 'Максимальный балл',
  STAGE: 'Этап',
  stage_num: 'Этап {stage}',
  OLIMPIC_PRINT_CLOSED_FOR_TEACHER:
    'Необходимо иметь минимум одного платного ученика, чтобы иметь возможность распечатывать задания для олимпиады',
  OLIMPIC_PRINT_CLOSED_FOR_STUDENT:
    'Необходимо оплатить доступ к платформе, чтобы иметь возможность распечатывать задания для олимпиады',
  PARTICIPANTS: 'Участники',
  OFFLINE_OLIMPIC_PARTICIPANTS: 'Участники Очной Олимпиады',
  PARTICIPANT_OVZ: 'Участник с ОВЗ',
  REQUIRED_OVZ_DOCUMENT:
    'Необходимо прислать справку с указанием категории ОВЗ, которая подходит под правила Ассоциации, в Телеграмм.',
  OVZ: 'ОВЗ',
  ASSOCIATION: 'Ассоциация',
  export: 'Экспорт',
  MAINTAINER: 'Сопровождающий',
  TSHORT: 'Футболка',
  TSHIRT_SIZE: 'Размер футболки',
  MAINTAINERS_COUNT: 'Кол-во сопровождающих',
  MAINTAINERS_LIMIT_FOR_1_PARTICIPANT:
    'Количество продаж сопровождающих для 1 участника',
  OLIMPIC_PARTICIPANT_SUCCESS_EDIT_MESSAGE:
    'Участник олимпиады успешно изменён',
  OLIMPIC_PARTICIPANTS_SUCCESS_EDIT_MESSAGE:
    'Участники олимпиады успешно изменены',
  PARTICIPANT_NOT_FOUND: 'Участник не найден',
  PAID: 'Платный',
  PAID_6_MONTHS: 'Требовать оплаты 6 мес',
  REQUIRED_6_MONTHS_OLIMPIC:
    'Олимпиада доступна только активным пользователям. Нужно иметь оплату доступа на платформу за последние 6 месяцев. Сейчас можете приобрести на последующие полгода. Ознакомьтесь с регламентом олимпиады',
  PAID_9_MONTHS: 'Требовать оплаты 9 мес',
  REQUIRED_9_MONTHS_OLIMPIC:
    'Олимпиада доступна только активным пользователям. Нужно иметь оплату доступа на платформу за последние 9 месяцев. Сейчас можете приобрести на последующий период «Подписка на год». Ознакомьтесь с регламентом олимпиады',
  CONFIRM_DELETE_USER:
    'ВНИМАНИЕ! Вы действительно хотите удалить данного пользователя? ОТМЕНА НЕВОЗМОЖНА!',
  CONFIRM_DELETE_USERS:
    'ВНИМАНИЕ! Вы действительно хотите удалить {count} пользователей? ОТМЕНА НЕВОЗМОЖНА!',
  CONFIRM_ALIVE_USER:
    'Вы действительно хотите восстановить данного пользователя?',
  DELETED_USERS_TITLE: 'Удалённые пользователи',
  CONFIRM_DELETE_OLIMPIC: 'Вы действительно хотите удалить данную олимпиаду?',
  CONFIRM_CLEAR_RESULT:
    'Вы действительно хотите сбросить результаты участника?',
  CONFIRM_DELETE_OFFLINE_PARTICIPANT:
    'Вы уверены в удалении билета участника и его сопровождающих?',
  CONFIRM_DELETE_ONLINE_PARTICIPANT: 'Вы уверены в удалении участника?',
  OLIMPIC_ENCOURAGE:
    'Желаем вам удачи и победы! После нажатия кнопки “Начать олимпиаду” вы не сможете вернyться назад, у вас будет только 1 попытка. Всю олимпиаду от начала до конца необходимо снимать. Видео загрузить на любое облачное хранилище и прикрепить ссылку.',
  OLIMPIC_LINK_WARN:
    'Видеоссылка обязательна, иначе призовое место будет понижено! Убедитесь, что доступ к видео открыт. Прикрепить ссылку доступно и после олимпиады до проверки результатов',
  OLIMPIC_CONGRATS: 'Поздравляем, ваша попытка завершена',
  LINK_NOTICE:
    'Ссылку можно прикрепить и потом на вкладке Олимпиада. Внимание! Без видео результат не будет засчитан.',
  END: 'Завершить',
  BOLD: 'Жирный',
  custom_text: 'Текст',
  CHAMPION: 'Чемпион',
  CHAMPION_EN: 'Champion',
  COMPETITOR: 'Участник',
  COMPETITOR_EN: 'Competitor',

  AddMENTAL: 'Сложение и вычитание Ментально',
  AddABACUS: 'Сложение и вычитание на абакусе',
  Card: 'Образ числа',
  MultiABACUS: 'Умножение на абакусе',
  DivisionABACUS: 'Деление на абакусе',
  Multi: 'Таблица умножения',
  Division: 'Таблица деления',
  MultiMENTAL: 'Умножение Ментально',
  DivisionMENTAL: 'Деление Ментально',
  MultiDivision: 'Таблица умножения и деления',

  AddMENTALen: 'Mental addition and subtraction',
  AddABACUSen: 'Addition and subtraction on the Abacus',
  Carden: 'Flash cards',
  MultiABACUSen: 'Multiplication on the Abacus',
  DivisionABACUSen: 'Division on the Abacus',
  Multien: 'Multiplication table',
  Divisionen: 'Division table',
  MultiMENTALen: 'Mental multiplication',
  DivisionMENTALen: 'Mental division',
  MultiDivisionen: 'Multiplication and division table',

  OPEN_TICKET_SALES: 'Открыть продажу билетов',
  SHOW_RESULTS: 'Показать результаты',
  SHOW_DIPLOMS: 'Показать дипломы',
  ACTIVE_SIMULATION: 'Включить симуляцию',
  SHOW_RATING: 'Показать рейтинг',
  SHOW_PRINT: 'Разрешить печать заданий',
  ACTIONS: 'Действия',
  ACTION: 'Действие',
  DIPLOM_EN: 'Diploma in English',
  DIPLOM_RU: 'Диплом на русском',
  AFTER: 'после',
  DICTANT_SETTINGS: 'Настройки диктанта',
  OLIMPIC_SUCCESS_RESULT: 'Результаты олимпиады успешно сохранены',
  PHONE_INVALID: 'Не верный номер телефона либо не заполнен.',
  EXAM_NEW: 'Экзамен создан',
  EXAM_FINISHED: 'Экзамен завершён',
  EXAM_IN_PROCESS: 'Экзамен выполняется',
  EXAM_ARCHIVE: 'Экзамен в архиве',
  EXAM_SUCCESSFUL: 'Экзамен выполнен успешно',
  EXAM_SUCCESSFUL_RUN: 'Вы сдали экзамен, ожидайте сертификат',
  EXAM_FAILURE: 'Экзамен не сдан',
  EXAM_FAILURE_RUN: 'Вы не сдали экзамен тренируйтесь ещё',
  EXAM_NOT_REQUIRED_NUMBER_OF_POINTS:
    'Пользователь не смог набрать нужное кол-во баллов (>= 70 за каждое задание)',
  EXAM_TEACHER_DNOT_RUN_CERTIFICATION_FOR_SAMA:
    'Педагог не может создать сертификат по sama, только администратор',
  EXAM_TEACHER_DNOT_RUN_CERTIFICATION_FOR_PAMA:
    'Педагог не может создать сертификат по pama, только администратор',
  EXAM_TEACHER_DNOT_RUN_CERTIFICATION:
    'Педагог не может создать сертификат, только администратор',
  // status homeworks
  new: 'Новое',
  process: 'Приступил(а) к выполнению',
  success: 'Выполнено',
  overfill: 'Перевыполнено',
  left_tasks: 'Осталось',

  HIT_1: 'Поразить педагога!',
  HIT_2: 'Удивить всех!',
  HIT_3: 'Сделать еще круче!',
  HIT_4: 'Можешь еще больше?',

  FLASH_CARD: 'Флэш-карты',
  FLASH_BATTLE: 'Флэш-баттл',
  ANZAN: 'Анзан',
  ANZAN_VIRTUAL: 'Виртуальный анзан',
  SOUND: 'Звук',
  AUTOREPEAT: 'Автоповтор',
  DICTANT: 'Диктант',
  SHOW_ANSWERS: 'Ответы диктанта',
  SHOW_EXAMPLES: 'Показать пример(ы)',
  HIDE_EXAMPLES: 'Показать пример(ы)',
  SHOW_ANSWER: 'Показать ответы',
  HIDE_ANSWER: 'Скрыть ответы',
  EXAMPLE: 'Пример',
  max_discharge: 'Максимальный разряд ответа (большая рыбка)',
  min_discharge: 'Минимальный разряд ответа (маленькая рыбка)',
  ABACUS_FULL: 'Отображать весь абакус',
  ABACUS_ALIGN: 'Считать по центру абакуса',

  // MODALS

  UPDATE_MODAL_TITLE: 'Уважаемый пользователь!',
  UPDATE_MODAL_MESSAGE:
    'Мы обновили нашу платформу! Исправили некоторые проблемы и добавили новые возможности. Обновите страницу, чтобы начать ими пользоваться!',
  UPDATE: 'Обновить',
  SKIP: 'Отложить',

  EXAMPLE_EXECUTED_CONGRATS: 'Поздравляем, это задание выполнено!',
  TIME_OVERWRITE_WARNING:
    'Обратите внимание: в тренажёре Шульте каждый новый результат перезаписывает предыдущий, даже если время выполнения увеличилось.',
  GO_NEXT_EXAMPLES: 'Перейти к другим заданиям',
  GO_LINK: 'Перейти',
  CONTINUE_EXAMPLE: 'Продолжить это задание',
  TEAMWORK_USERS_INVITE_TITLE: 'Пригласите учеников, которые сейчас онлайн!',
  TEAMWORK_INVITE_TITLE: '{user} приглашает вас на занятие!',
  INVITE_ACTION: 'Пригласить',
  INVITED: 'Приглашен',
  ACCEPT: 'Принять',
  DECLINE: 'Отклонить',
  TEAMWORK_KICK_TITLE: 'Вы действительно хотите исключить {user} из занятия?',
  'teamwork.user.joined': 'Ученик подключен',
  'teamwork.user.left': 'Ученик покинул тренажер',
  // Painter

  CLEAR_DRAWING: 'Очистить',
  SIZE: 'Размер',
  COLOR: 'Цвет',
  PIXELS_SHORT: 'пкс',

  // Clues

  S_REFERRAL_CLUE:
    'Отправь ссылку друзьям! Когда они зарегистрируются и оплатят доступ, то получишь 25 юкоинов на свой счет',
  T_TO_S_REFERRAL_CLUE_1:
    'Отправь своим ученикам и любым другим! Когда они зарегистрируются и оплатят доступ, то получишь 25 юкоинов на свой счет!',
  T_TO_S_REFERRAL_CLUE_2: 'Внимание: ',
  T_TO_S_REFERRAL_CLUE_3:
    'своих учеников все равно нужно подключить к себе через Справочники/Ученики/Добавить из списка',
  T_TO_T_REFERRAL_CLUE:
    'Отправь знакомым педагогам! Когда они зарегистрируются и подключат к себе учеников, которые оплатят доступ, то получишь 50 юкоинов на свой счет!',

  RATING_CLUE: 'Рейтинг обновляется каждый день в 00:00 (Мск)',

  S_ACCESS_CLUE: 'С момента оплаты предоставляется доступ ко всем вкладкам',
  S_CERT_EXAM_CLUE:
    'После оплаты сертификата сообщите педагогу или администратору для назначения экзамена',
  OLIMPIC_PARTICIPATION_CLUE:
    'Для участия в олимпиадах отдельная оплата. Симуляции и участие в онлайн-олимпиаде возможны только при оплаченном доступе к платформе',
  BALANCE_CLUE_1: 'Все цены в нашей валюте, юкоинах (1 юкоин = 1 рубль). ',
  BALANCE_CLUE_2:
    'Для покупки пополните баланс юкоинов, нажав “Пополнить счет”. ',
  BALANCE_CLUE_3:
    'Не забудьте потом совершить покупку для открытия оплаченных функций!',
  T_ACCESS_CLUE_1: 'Здесь приобретаете доступ ученикам. ',
  T_ACCESS_CLUE_2:
    'С момента оплаты откроются вкладки на оплаченное количество дней. ',
  T_ACCESS_CLUE_3: 'Для оплаты из ',
  T_ACCESS_CLUE_4: 'купленного пакета доступов ',
  T_ACCESS_CLUE_5: 'выбирайте только “1 месяц из пакета”!',

  T_CERT_EXAM_CLUE:
    'После оплаты сертификата ученику можете создать ему экзамен на вкладке “Сертификация/Экзамен” или обратиться к администратору для назначения экзамена педагогу. Для педагога экзамен UAMAP только после обучения',
  CERT_EXAM_CLUE_2:
    'Вкладка “Экзамен” доступна только при наличии оплаченного доступа к платформе',
  ACCESS_PACKET_CLUE_1:
    'Доступы ученикам на месяц по выгодной цене (в расчете на 1 ученика). ',
  ACCESS_PACKET_CLUE_2:
    'Пакеты не имеют ограничений для хранения, суммируются все. Можете в любой момент продлить доступ ученикам из пакета. ',
  ACCESS_PACKET_CLUE_3:
    'Остаток смотрите в Доступ к платформе “Подписка на 1 месяц из пакета (Осталось: …)“',

  NEW_HOMEWORK_CLUE_1:
    'Здесь видны только текущие настройки домашних заданий, которые актуальны. Как только срок ДЗ истечет, то оно пропадет из списка. ',
  NEW_HOMEWORK_CLUE_2:
    'Можете редактировать задания, чтобы не продублировать слишком много ДЗ на одного ученика. ',
  NEW_HOMEWORK_CLUE_3: 'Сделанные ДЗ смотрите на вкладке “На проверку”',

  CREATE_HOMEWORK_CLUE:
    'При создании учитывайте, что ДЗ считается сделанным, если выполнены ВСЕ тренажеры до заданного количества примеров. ',
  DAILY_HOMEWORK_CLUE:
    'Настройка “Ежедневно” задает ДЗ как новое каждый день. Если ученик не доделал до конца в течение дня (нет статуса Выполнено или Перевыполнено), то не сохраняется. Мы за позитивную мотивацию - долг по ДЗ не отображается нигде. ',
  DAILY_MAX_HOMEWORK_CLUE:
    'На данный момент невозможно создать более {count} ежедневных домашних заданий. Чем больше учеников - тем выше лимит',
  DEADLINE_HOMEWORK_CLUE:
    'Если важно просто довести ДЗ до статуса сделанного в течение долгого времени, то выберите настройку “Выполнить до”',

  COMPLETED_HOMEWORK_CLUE_1:
    'Сделанными ДЗ считаются, когда есть статус Выполнено или Перевыполнено. ',
  COMPLETED_HOMEWORK_CLUE_2:
    'Они попадают сюда на следующий день после выполнения учеником. Т.к. ученику дается возможность перевыполнить заданный объем ДЗ в течение дня после того, как он его сделал. Обратите внимание на счетчики выполненных и перевыполненных при проверке. ',
  COMPLETED_HOMEWORK_CLUE_3: 'Оцените ДЗ при помощи звезд и комментария',
  EXAM_CLUE:
    'Процесс сдачи экзамена нужно снять на видео. И прикрепить ссылку на него',
  EXAM_CLUE_2:
    'Чтобы прикрепить ссылку, можно загрузить видео на облачный сервис, такой как Google Диск, Яндекс Диск и т.д.',
  ABACUS_CLUE:
    'При нажатии нажатии на перекладину абакуса появляется метка. При повторном нажатии - метка убирается.',

  CREATE_PARTICIPANT: 'Создать нового участника',
  EDIT_PARTICIPANT: 'Редактировать участника',

  SELECT_COUNTRY: 'Выбор страны',
  SELECT_CATEGORY: 'Выбор категории',
  OLIMPIC_CHOOSE_CATEGORY:
    'Выбирайте категорию выше, если вы ранее уже выигрывали приз. При несоблюдении правил возможна дисквалификация',

  DELEGATE: 'Представитель',

  CREATE_DELEGATE: 'Создать нового представителя',
  EDIT_DELEGATE: 'Редактировать представителя',
  SET_PLACE: 'Назначить место',
  CLEAR_RESULT: 'Очистить результаты',

  REGULATIONS: 'Регламент',
  INFORMATION: 'Информация',

  DIPLOMAS: 'Дипломы',
  MENTAL: 'Mental',
  SELECT_PLACE: 'Select place',

  SOUND_CLUE: 'В вашем браузере не поддерживается синтез речи',

  'table.no-match': 'К сожалению, подходящих записей не найдено',
  'table.tooltip': 'Сортировать',
  'table.next': 'Следующая страница',
  'table.previous': 'Предыдущая страница',
  'table.rows_per_page': 'Строк на странице:',
  'table.display_rows': 'из',
  'table.jump_to_page': 'Перейти на страницу:',
  'table.search': 'Поиск',
  'table.download_csv': 'Скачать',
  'table.print': 'Печать',
  'table.view_columns': 'Посмотреть столбцы',
  'table.filter_table': 'Фильтры',
  'table.all': 'Все',
  'table.filter_title': 'Фильтры',
  'table.reset': 'Сбросить',
  'table.title': 'Показать столбцы',
  'table.title_aria': 'Показать/Спрятать столбцы',
  'table.text': 'выбран(о)',
  'table.delete': 'Удалить',
  'table.delete_aria': 'Удалить выделенные строки',

  // ----------  PRODUCT TAB
  'product.type_1.1': 'Доступ к платформе на 1 месяц',
  'product.type_1.6': 'Доступ к платформе на 6 месяцев',
  'product.type_1.12': 'Доступ к платформе на 12 месяцев',
  'product.type_2.10': 'Пакет доступов на 10 учеников',
  'product.type_2.25': 'Пакет доступов на 25 учеников',
  'product.type_2.50': 'Пакет доступов на 50 учеников',
  'product.type_3.1': 'Доступ из пакета',
  'product.type_4.0': 'Доступ к экзамену PAMA',
  'product.type_5.0': 'Доступ к экзамену UAMAP',
  'product.type_6.0': 'Доступ к онлайн олимпиаде',
  'product.type_7.0': 'Доступ к очной олимпиаде',
  'product.type_8.0': 'Билет сопровождающему',
  'product.type_9.0': 'Доступ к PAMA олимпиаде',
  'product.type_10.0': 'Доступ к очной PAMA Global олимпиаде',
  'product.type_11.0': 'Билет сопровождающему',

  // EXAMS

  ONLY_MENTAL: 'только МЕНТАЛЬНО',

  ABACUS_ARITHMETIC_ADD_TEACHER_LEVEL_1_SECTION_1: '10 примеров 3-4D10R абакус',
  ABACUS_ARITHMETIC_ADD_TEACHER_LEVEL_1_SECTION_2: '20 примеров 3D*3D',
  ABACUS_ARITHMETIC_ADD_TEACHER_LEVEL_1_SECTION_3: '20 примеров 4-5D/2-3D',
  ABACUS_ARITHMETIC_ADD_TEACHER_LEVEL_1_SECTION_4: '10 примеров 2D6R',
  ABACUS_ARITHMETIC_ADD_TEACHER_LEVEL_1_SECTION_5: '20 примеров 2D*1D, 3D/1D',

  ABACUS_ARITHMETIC_ADD_TEACHER_LEVEL_2_SECTION_1: '10 примеров 2-3D10R абакус',
  ABACUS_ARITHMETIC_ADD_TEACHER_LEVEL_2_SECTION_2: '20 примеров 2D*2D',
  ABACUS_ARITHMETIC_ADD_TEACHER_LEVEL_2_SECTION_3: '20 примеров 3-4D/1D',
  ABACUS_ARITHMETIC_ADD_TEACHER_LEVEL_2_SECTION_4: '10 примеров 1D7R',
  ABACUS_ARITHMETIC_ADD_TEACHER_LEVEL_2_SECTION_5: '10 примеров 1-2D5R',

  ABACUS_ARITHMETIC_ADD_TEACHER_LEVEL_3_SECTION_1:
    '50 примеров таблица умножения',
  ABACUS_ARITHMETIC_ADD_TEACHER_LEVEL_3_SECTION_2:
    '50 примеров таблица деления',
  ABACUS_ARITHMETIC_ADD_TEACHER_LEVEL_3_SECTION_3: '20 примеров 1-2D10R абакус',
  ABACUS_ARITHMETIC_ADD_TEACHER_LEVEL_3_SECTION_4: '20 примеров 1D6R',

  ABACUS_ARITHMETIC_ADD_LEVEL_6_SECTION_1: '10 примеров 3-4D10R абакус',
  ABACUS_ARITHMETIC_MULTIPLICATION_LEVEL_6_SECTION_2: '20 примеров 3D*2D',
  ABACUS_ARITHMETIC_DIVISION_LEVEL_6_SECTION_3: '20 примеров 3-4D/2-3D',
  ABACUS_ARITHMETIC_ADD_LEVEL_6_SECTION_4: '10 примеров 2D4R',
  ABACUS_ARITHMETIC_MULTIPLICATION_LEVEL_6_SECTION_5: '20 примеров 2-3D*1D',

  ABACUS_ARITHMETIC_ADD_LEVEL_7_SECTION_1: '10 примеров 2-3D10R абакус',
  ABACUS_ARITHMETIC_MULTIPLICATION_LEVEL_7_SECTION_2: '20 примеров 2D*2D',
  ABACUS_ARITHMETIC_DIVISION_LEVEL_7_SECTION_3: '20 примеров 3-4D/1D',
  ABACUS_ARITHMETIC_ADD_LEVEL_7_SECTION_4: '10 примеров 1D7R',
  ABACUS_ARITHMETIC_ADD_LEVEL_7_SECTION_5: '10 примеров 1-2D5R',

  ABACUS_ARITHMETIC_ADD_LEVEL_8_SECTION_1: '10 примеров 2D10R абакус',
  ABACUS_ARITHMETIC_MULTIPLICATION_LEVEL_8_SECTION_2: '20 примеров 3D*1D',
  ABACUS_ARITHMETIC_DIVISION_LEVEL_8_SECTION_3: '20 примеров 2-3D/1D',
  ABACUS_ARITHMETIC_ADD_LEVEL_8_SECTION_4: '10 примеров 1D6R',
  ABACUS_ARITHMETIC_ADD_LEVEL_8_SECTION_5: '10 примеров 1-2D4R',

  ABACUS_ARITHMETIC_ADD_LEVEL_9_SECTION_1: '20 примеров таблица умножения',
  ABACUS_ARITHMETIC_ADD_LEVEL_9_SECTION_2: '10 примеров 1-2D10R абакус',
  ABACUS_ARITHMETIC_ADD_LEVEL_9_SECTION_3: '10 примеров 2D4R абакус',
  ABACUS_ARITHMETIC_ADD_LEVEL_9_SECTION_4: '10 примеров 1D4R',
  ABACUS_ARITHMETIC_ADD_LEVEL_9_SECTION_5: '10 примеров 1D5R',

  ABACUS_ARITHMETIC_ADD_LEVEL_10_SECTION_1: '20 примеров состав числа 10',
  ABACUS_ARITHMETIC_ADD_LEVEL_10_SECTION_2: '10 примеров 1D10R абакус',
  ABACUS_ARITHMETIC_ADD_LEVEL_10_SECTION_3: '10 примеров 2D4RF5 абакус',
  ABACUS_ARITHMETIC_ADD_LEVEL_10_SECTION_4: '10 примеров 1D5RF5',
  ABACUS_ARITHMETIC_ADD_LEVEL_10_SECTION_5: '10 примеров 1D4RF10',

  ABACUS_ARITHMETIC_ADD_LEVEL_11_SECTION_1: '20 примеров состав числа 10',
  ABACUS_ARITHMETIC_ADD_LEVEL_11_SECTION_2: '10 примеров 1D8RF10 абакус',
  ABACUS_ARITHMETIC_ADD_LEVEL_11_SECTION_3: '10 примеров 2D3RF5 абакус',
  ABACUS_ARITHMETIC_ADD_LEVEL_11_SECTION_4: '10 примеров 1D5RNF',
  ABACUS_ARITHMETIC_ADD_LEVEL_11_SECTION_5: '10 примеров 1D3RF5',

  ABACUS_ARITHMETIC_ADD_LEVEL_12_SECTION_1: '20 примеров состав числа 10',
  ABACUS_ARITHMETIC_ADD_LEVEL_12_SECTION_2: '10 примеров 1D6RF5 абакус',
  ABACUS_ARITHMETIC_ADD_LEVEL_12_SECTION_3: '10 примеров 2D3RNF абакус',
  ABACUS_ARITHMETIC_ADD_LEVEL_12_SECTION_4: '10 примеров 1D4RNF',
  ABACUS_ARITHMETIC_ADD_LEVEL_12_SECTION_5: '20 примеров флешкарты 2D',

  ABACUS_ARITHMETIC_ADD_LEVEL_13_SECTION_1: '20 примеров состав числа 5',
  ABACUS_ARITHMETIC_ADD_LEVEL_13_SECTION_2: '10 примеров 1D5RNF абакус',
  ABACUS_ARITHMETIC_ADD_LEVEL_13_SECTION_3:
    '10 зеркальных примеров 2D3RNF абакус',
  ABACUS_ARITHMETIC_ADD_LEVEL_13_SECTION_4: '10 примеров 1D3RNF',
  ABACUS_ARITHMETIC_ADD_LEVEL_13_SECTION_5: '20 примеров флешкарты 1D',

  VISIBILITY: 'Видимость',
  HISTORY_TITLE: 'История операций',
  OLIMP_PURCHASES: 'Покупки Олимпиады',
  CREATOR: 'Создатель',

  // НОВОСТИ
  files: 'Файлы',
  fullscreen: 'Полный экран',
  DROP_FILES: 'Нажмите, переместите или вставьте файлы для загрузки...',
  NEWS_TYPE: 'Тематика новости',
  DEFAULT_NEWS: 'Обычная',
  UPDATE_NEWS: 'Обновление',
  FEATHERS_NEWS: 'Перья',
  WHITE_NEWS: 'Белая',
  BLUE_NEWS: 'Синяя',
  RED_NEWS: 'Красная',
  YELLOW_NEWS: 'Желтая',
  GREEN_NEWS: 'Зеленая',
  PURPLE_NEWS: 'Фиолетовая',

  NEWS_UNCHECKED: 'Что тут у нас новенького?',
  NEWS_CHECKED: 'Это мы уже смотрели',
  NEWS_CHECKED_ALL: 'Вы в курсе всех событий! Так держать!',
  NEWS_HEADER: 'Ну и новости!',
  NEWS_EMPTY: 'Новостей пока нет. Но они обязательно появятся!',
  FIRST_PAYMENT: 'Первая оплата',
  INVITED_STUDENTS_2: 'Приглашенные ученики',
  INVITED_TEACHERS_2: 'Приглашенные преподаватели',

  GROUP_MEMBERS: 'Состав группы',
  RESTORE_PASSWORD: 'Восстановить пароль',
  DUPLICATES_TITLE: 'Возможно, это ваш аккаунт?',
  DIRECTORY_DUPLICATES_TITLE: 'Найдены похожие',
  REGISTER_NEW: 'Зарегистрировать новый',

  // register forms
  REGISTER_AS: 'В качестве кого Вы хотите зарегистрироваться на платформе?',
  REGISTER_AS_PARENT: 'Как родитель ученика',
  REGISTER_AS_TEACHER: 'Как преподаватель',

  // ACHIEVEMENTS
  // student
  'achievement.student.first_homework.title': 'Начало положено',
  'achievement.student.first_homework.desc':
    'Ты сделал свою первую домашку, так держать!',
  'achievement.student.2_homeworks_per_day.title': 'Раз, да еще раз!',
  'achievement.student.2_homeworks_per_day.desc':
    'За сегодня это уже вторая домашняя работа. Тебя не остановить!',
  'achievement.student.homeworks_for_week_comleted.title': 'Проще простого!',
  'achievement.student.homeworks_for_week_comleted.desc':
    'Молодец, ты справляешься со всей домашней работой уже целую неделю!',
  'achievement.student.homeworks_for_month_comleted.title': 'Миссия выполнена',
  'achievement.student.homeworks_for_month_comleted.desc':
    'Мы в восторге от твоей выдержки! Ты выполнял всю домашнюю работу в течение месяца.',
  'achievement.student.10_homeworks_completed.title': 'Мал да удал!',
  'achievement.student.10_homeworks_completed.desc':
    'Отлично! Ты уже сделал 10 домашних работ на портале.',
  'achievement.student.50_homeworks_completed.title': 'Есть результат!',
  'achievement.student.50_homeworks_completed.desc':
    'Отлично! Ты уже сделал 50 домашних работ на портале.',
  'achievement.student.100_homeworks_completed.title': 'Меня не остановить!',
  'achievement.student.100_homeworks_completed.desc':
    'Отлично! Ты уже сделал 100 домашних работ на портале.',
  'achievement.student.500_homeworks_completed.title':
    'Бесконечность не предел!',
  'achievement.student.500_homeworks_completed.desc':
    'Отлично! Ты уже сделал 500 домашних работ на портале.',
  'achievement.student.set_avatar.title': 'Улыбочку!',
  'achievement.student.set_avatar.desc':
    'Награда за установление или смену аватарки профиля',
  'achievement.student.first_olimpic.title': 'Попытка не пытка',
  'achievement.student.first_olimpic.desc':
    'Поздравляем с первым участием в олимпиаде!',
  'achievement.student.olimpic_prize_place.title': 'Дайте мне приз!',
  'achievement.student.olimpic_prize_place.desc':
    'Поздравляем с призовым местом в олимпиаде!',
  'achievement.student.olimpic_first_place.title': 'Лучше всех!',
  'achievement.student.olimpic_first_place.desc':
    'Поздравляем с победой в олимпиаде!',
  'achievement.student.first_exam_access.title': 'Я готов!',
  'achievement.student.first_exam_access.desc':
    'Ты решился сдать свой первый экзамен, так держать!',
  'achievement.student.access_3_month.title': 'Вместе веселее шагать...',
  'achievement.student.access_3_month.desc':
    'Ура! Ты занимаешься с нами уже 3 месяца подряд.',
  'achievement.student.access_6_month.title': 'Полгода, как один день.',
  'achievement.student.access_6_month.desc':
    'Ура! Ты занимаешься с нами уже 6 месяцев подряд.',
  'achievement.student.access_12_month.title': 'Не сверну с пути...',
  'achievement.student.access_12_month.desc':
    'Ура! Ты занимаешься с нами уже год.',
  'achievement.student.student_try_uamap.title': 'Мне не только посмотреть!',
  'achievement.student.student_try_uamap.desc':
    'Награда за первую попытку симулировать экзамен UAMAP',
  'achievement.student.student_try_sama_mental.title':
    'Начало ментального пути...',
  'achievement.student.student_try_sama_mental.desc':
    'Награда за первую попытку симулировать экзамен ментальная PAMA GLOBAL',
  'achievement.student.student_try_sama_abacus.title': 'В начале был абакус...',
  'achievement.student.student_try_sama_abacus.desc':
    'Награда за первую попытку симулировать экзамен PAMA GLOBAL на абакусе',

  'achievement.student.uamap_13.title': 'Медаль UAMAP 13',
  'achievement.student.uamap_13.desc':
    'Поздравляем, ты сдал экзамен UAMAP 13го уровня!',
  'achievement.student.uamap_12.title': 'Медаль UAMAP 12',
  'achievement.student.uamap_12.desc':
    'Поздравляем, ты сдал экзамен UAMAP 12го уровня!',
  'achievement.student.uamap_11.title': 'Медаль UAMAP 11',
  'achievement.student.uamap_11.desc':
    'Поздравляем, ты сдал экзамен UAMAP 11го уровня!',
  'achievement.student.uamap_10.title': 'Медаль UAMAP 10',
  'achievement.student.uamap_10.desc':
    'Поздравляем, ты сдал экзамен UAMAP 10го уровня!',
  'achievement.student.uamap_9.title': 'Медаль UAMAP 9',
  'achievement.student.uamap_9.desc':
    'Поздравляем, ты сдал экзамен UAMAP 9го уровня!',
  'achievement.student.uamap_8.title': 'Медаль UAMAP 8',
  'achievement.student.uamap_8.desc':
    'Поздравляем, ты сдал экзамен UAMAP 8го уровня!',
  'achievement.student.uamap_7.title': 'Медаль UAMAP 7',
  'achievement.student.uamap_7.desc':
    'Поздравляем, ты сдал экзамен UAMAP 7го уровня!',
  'achievement.student.uamap_6.title': 'Медаль UAMAP 6',
  'achievement.student.uamap_6.desc':
    'Поздравляем, ты сдал экзамен UAMAP 6го уровня!',

  'achievement.student.sama_abacus_12.title': 'Орден Абакус PAMA GLOBAL 12',
  'achievement.student.sama_abacus_12.desc':
    'Поздравляем, ты сдал экзамен абакус PAMA GLOBAL 12го уровня!',
  'achievement.student.sama_abacus_11.title': 'Орден Абакус PAMA GLOBAL 11',
  'achievement.student.sama_abacus_11.desc':
    'Поздравляем, ты сдал экзамен абакус PAMA GLOBAL 11го уровня!',
  'achievement.student.sama_abacus_10.title': 'Орден Абакус PAMA GLOBAL 10',
  'achievement.student.sama_abacus_10.desc':
    'Поздравляем, ты сдал экзамен абакус PAMA GLOBAL 10го уровня!',
  'achievement.student.sama_abacus_9.title': 'Орден Абакус PAMA GLOBAL 9',
  'achievement.student.sama_abacus_9.desc':
    'Поздравляем, ты сдал экзамен абакус PAMA GLOBAL 9го уровня!',
  'achievement.student.sama_abacus_8.title': 'Орден Абакус PAMA GLOBAL 8',
  'achievement.student.sama_abacus_8.desc':
    'Поздравляем, ты сдал экзамен абакус PAMA GLOBAL 8го уровня!',
  'achievement.student.sama_abacus_7.title': 'Орден Абакус PAMA GLOBAL 7',
  'achievement.student.sama_abacus_7.desc':
    'Поздравляем, ты сдал экзамен абакус PAMA GLOBAL 7го уровня!',
  'achievement.student.sama_abacus_6.title': 'Орден Абакус PAMA GLOBAL 6',
  'achievement.student.sama_abacus_6.desc':
    'Поздравляем, ты сдал экзамен абакус PAMA GLOBAL 6го уровня!',
  'achievement.student.sama_abacus_5.title': 'Орден Абакус PAMA GLOBAL 5',
  'achievement.student.sama_abacus_5.desc':
    'Поздравляем, ты сдал экзамен абакус PAMA GLOBAL 5го уровня!',
  'achievement.student.sama_abacus_4.title': 'Орден Абакус PAMA GLOBAL 4',
  'achievement.student.sama_abacus_4.desc':
    'Поздравляем, ты сдал экзамен абакус PAMA GLOBAL 4го уровня!',
  'achievement.student.sama_abacus_3.title': 'Орден Абакус PAMA GLOBAL 3',
  'achievement.student.sama_abacus_3.desc':
    'Поздравляем, ты сдал экзамен абакус PAMA GLOBAL 3го уровня!',
  'achievement.student.sama_abacus_2.title': 'Орден Абакус PAMA GLOBAL 2',
  'achievement.student.sama_abacus_2.desc':
    'Поздравляем, ты сдал экзамен абакус PAMA GLOBAL 2го уровня!',
  'achievement.student.sama_abacus_1.title': 'Орден Абакус PAMA GLOBAL 1',
  'achievement.student.sama_abacus_1.desc':
    'Поздравляем, ты сдал экзамен абакус PAMA GLOBAL 1го уровня!',

  'achievement.student.sama_mental_12.title':
    'Корона Ментальная PAMA GLOBAL 12',
  'achievement.student.sama_mental_12.desc':
    'Поздравляем, ты сдал экзамен ментальная PAMA GLOBAL 12го уровня!',
  'achievement.student.sama_mental_11.title':
    'Корона Ментальная PAMA GLOBAL 11',
  'achievement.student.sama_mental_11.desc':
    'Поздравляем, ты сдал экзамен ментальная PAMA GLOBAL 11го уровня!',
  'achievement.student.sama_mental_10.title':
    'Корона Ментальная PAMA GLOBAL 10',
  'achievement.student.sama_mental_10.desc':
    'Поздравляем, ты сдал экзамен ментальная PAMA GLOBAL 10го уровня!',
  'achievement.student.sama_mental_9.title': 'Корона Ментальная PAMA GLOBAL 9',
  'achievement.student.sama_mental_9.desc':
    'Поздравляем, ты сдал экзамен ментальная PAMA GLOBAL 9го уровня!',
  'achievement.student.sama_mental_8.title': 'Корона Ментальная PAMA GLOBAL 8',
  'achievement.student.sama_mental_8.desc':
    'Поздравляем, ты сдал экзамен ментальная PAMA GLOBAL 8го уровня!',
  'achievement.student.sama_mental_7.title': 'Корона Ментальная PAMA GLOBAL 7',
  'achievement.student.sama_mental_7.desc':
    'Поздравляем, ты сдал экзамен ментальная PAMA GLOBAL 7го уровня!',
  'achievement.student.sama_mental_6.title': 'Корона Ментальная PAMA GLOBAL 6',
  'achievement.student.sama_mental_6.desc':
    'Поздравляем, ты сдал экзамен ментальная PAMA GLOBAL 6го уровня!',
  'achievement.student.sama_mental_5.title': 'Корона Ментальная PAMA GLOBAL 5',
  'achievement.student.sama_mental_5.desc':
    'Поздравляем, ты сдал экзамен ментальная PAMA GLOBAL 5го уровня!',
  'achievement.student.sama_mental_4.title': 'Корона Ментальная PAMA GLOBAL 4',
  'achievement.student.sama_mental_4.desc':
    'Поздравляем, ты сдал экзамен ментальная PAMA GLOBAL 4го уровня!',
  'achievement.student.sama_mental_3.title': 'Корона Ментальная PAMA GLOBAL 3',
  'achievement.student.sama_mental_3.desc':
    'Поздравляем, ты сдал экзамен ментальная PAMA GLOBAL 3го уровня!',
  'achievement.student.sama_mental_2.title': 'Корона Ментальная PAMA GLOBAL 2',
  'achievement.student.sama_mental_2.desc':
    'Поздравляем, ты сдал экзамен ментальная PAMA GLOBAL 2го уровня!',
  'achievement.student.sama_mental_1.title': 'Корона Ментальная PAMA GLOBAL 1',
  'achievement.student.sama_mental_1.desc':
    'Поздравляем, ты сдал экзамен ментальная PAMA GLOBAL 1го уровня!',

  // teacher
  'achievement.teacher.first_student_exam_completed.title': 'Первый пошел!',
  'achievement.teacher.first_student_exam_completed.desc':
    '1 ученик сдал любой экзамен',
  'achievement.teacher.10_student_exams_completed.title': 'Собрал команду!',
  'achievement.teacher.10_student_exams_completed.desc':
    '10 учеников сдали любой экзамен',
  'achievement.teacher.50_student_exams_completed.title': 'Наставник',
  'achievement.teacher.50_student_exams_completed.desc':
    '50 учеников сдали любой экзамен',
  'achievement.teacher.homeworks_for_week_comleted.title': 'Показал как',
  'achievement.teacher.homeworks_for_week_comleted.desc':
    'Поздравляем, ваш ученик справлялся с домашней работой всю неделю!',
  'achievement.teacher.olimpic_prize_1.title': 'Поделился опытом',
  'achievement.teacher.olimpic_prize_1.desc':
    'Поздравляем, ваш ученик занял призовое место на олимпиаде!',
  'achievement.teacher.olimpic_prize_3.title': 'Сенсей',
  'achievement.teacher.olimpic_prize_3.desc':
    'Поздравляем, 3 ваших ученика заняли призовое место на олимпиаде!',
  'achievement.teacher.olimpic_prize_5.title': 'Мудрый учитель',
  'achievement.teacher.olimpic_prize_5.desc':
    'Поздравляем, 5 ваших учеников заняли призовое место на олимпиаде!',
  'achievement.teacher.10_homeworks_created.title': 'Не время отдыхать!',
  'achievement.teacher.10_homeworks_created.desc':
    'Неплохо! Вы задали уже 10 домашних заданий своим ученикам.',
  'achievement.teacher.100_homeworks_created.title': 'Знаю свое дело!',
  'achievement.teacher.100_homeworks_created.desc':
    'Неплохо! Вы задали уже 100 домашних заданий своим ученикам.',
  'achievement.teacher.500_homeworks_created.title': 'Много не бывает!',
  'achievement.teacher.500_homeworks_created.desc':
    'Неплохо! Вы задали уже 500 домашних заданий своим ученикам.',
  'achievement.teacher.referal_created_student_1.title': '(+1)',
  'achievement.teacher.referal_created_student_1.desc':
    'Поздравляем! Вы привели нового ученика на платформу!',
  'achievement.teacher.referal_created_student_5.title': 'Вместе веселее',
  'achievement.teacher.referal_created_student_5.desc':
    'Поздравляем! Вы привели уже 5 учеников на платформу!',
  'achievement.teacher.referal_created_student_10.title': 'Мы - команда!',
  'achievement.teacher.referal_created_student_10.desc':
    'Поздравляем! Вы привели уже 10 учеников на платформу!',
  'achievement.teacher.referal_created_teacher_1.title': 'Уже не один!',
  'achievement.teacher.referal_created_teacher_1.desc':
    'Поздравляем! Вы привели нового педагога на платформу!',
  'achievement.teacher.referal_created_teacher_3.title': 'Все свои!',
  'achievement.teacher.referal_created_teacher_3.desc':
    'Поздравляем! Вы привели уже 3 педагога на платформу!',
  'achievement.teacher.referal_created_teacher_5.title': 'Люблю свою работу!',
  'achievement.teacher.referal_created_teacher_5.desc':
    'Поздравляем! Вы привели уже 5 педагогов на платформу!',
  'achievement.teacher.pay_for_student_access.title': 'Вклад в будущее',
  'achievement.teacher.pay_for_student_access.desc':
    'Вы только что оплатили подписку вашего ученика на платформу. Получите свою награду!',
  'achievement.teacher.pay_for_student_olimpic.title': 'Проявление заботы',
  'achievement.teacher.pay_for_student_olimpic.desc':
    'Вы только что оплатили участие вашего ученика в олимпиаде. Получите свою награду!',
  'achievement.teacher.topup_account.title': 'Точно пригодится!',
  'achievement.teacher.topup_account.desc':
    'Вы пополнили баланс и за это получаете небольшой презент!',
  'achievement.teacher.set_avatar.title': 'Улыбочку!',
  'achievement.teacher.set_avatar.desc':
    'Награда за установление или смену аватарки профиля',
  'achievement.teacher.complete_profile.title': 'Свой человек!',
  'achievement.teacher.complete_profile.desc':
    'Награда за заполнение всех полей в профиле',
  'achievement.teacher.uamap_1.title': 'Сертификат UAMAP 1',
  'achievement.teacher.uamap_1.desc':
    'Поздравляем, Вы справились с экзаменом UAMAP 1го уровня',
  'achievement.teacher.uamap_2.title': 'Сертификат UAMAP 2',
  'achievement.teacher.uamap_2.desc':
    'Поздравляем, Вы справились с экзаменом UAMAP 2го уровня',
  'achievement.teacher.uamap_3.title': 'Сертификат UAMAP 3',
  'achievement.teacher.uamap_3.desc':
    'Поздравляем, Вы справились с экзаменом UAMAP 3го уровня',
  'achievement.teacher.sama_3.title': '3 звезды PAMA GLOBAL',
  'achievement.teacher.sama_3.desc':
    'Поздравляем, вы получили 3 звезды PAMA GLOBAL',
  'achievement.teacher.sama_5.title': '2 звезды PAMA GLOBAL',
  'achievement.teacher.sama_5.desc':
    'Поздравляем, Вы получили 2 звезды PAMA GLOBAL',
  'achievement.teacher.sama_7.title': 'Звезда PAMA GLOBAL',
  'achievement.teacher.sama_7.desc':
    'Поздравляем, Вы получили 1 звезду PAMA GLOBAL',

  // other
  SOUND_ON: 'вкл',
  DAILY: 'Ежедневно',
  COMPLETE_BY: 'Выполнить до',
  SPECIFIC_DAYS: 'На определенные дни',
  SPECIFIC_DAYS_MULTIPLE: 'На определенные дни (можно указать несколько дат)',
  MONTHS_LIST:
    'Январь,Февраль,Март,Апрель,Май,Июнь,Июль,Август,Сентябрь,Октябрь,Ноябрь,Декабрь',
  MONTHS_SHORT: 'янв,фев,мар,апр,май,июн,июл,авг,сен,окт,ноя,дек',
  WEEKDAYS_LONG:
    'Воскресенье,Понедельник,Вторник,Среда,Четверг,Пятница,Суббота',
  WEEKDAYS_SHORT: 'вс,пн,вт,ср,чт,пт,сб',
  NEXT_MONTH: 'следующий месяц',
  PREVIOUS_MONTH: 'предыдущий месяц',
  GENDER_MALE: 'Мужской',
  GENDER_FEMALE: 'Женский',
  THEME_STANDARD: 'Стандартные',
  THEME_STANDARD_DESC: 'Темы оформления доступные для всех пользователей',
  THEME_UNIQUE: 'Уникальные',
  THEME_UNIQUE_DESC: 'Темы оформления доступные за волшебные перья',
  BRAND_THEME: 'Фирменная тема',
  ABACUS_COLOR_CHOICE:
    'Здесь ты можешь выбрать цвет косточек для своего абакуса',
  EGYPT_THEME_DESC:
    'Погрузитесь в атмосферу древнего Египта, где мир полон тайн и загадок!',
  INSTALL: 'Установить',
  OWL_GREETING: 'Привет, меня зовут сова Юни',
  CONFIGURE_TRAINER: 'Настроить тренажер',
  CHOOSE_TASK_TEXT: 'Выбери подходящее задание и удиви меня результатом',
  QUICK_START: 'Быстрый старт',
  QUICK_START_DESC:
    'Нажми тренироваться прямо сейчас с набором случайных настроек',
  // шульте
  TABLE_SIZE: 'Размер таблицы',
  NUMBER_DIGITS: 'Разрядность чисел',
  SHUFFLE_ON_CLICK: 'Перемешивать по клику',
  CENTER_DOT: 'Точка по центру',
  SYMBOL_ORDER: 'Порядок символов',
  TABLE_TYPE: 'Тип таблицы',
  DIRECT_ORDER: 'Прямой',
  REVERSE_ORDER: 'Обратный',
  RANDOM_ORDER: 'Случайный',
  NUMBERS: 'Цифры',
  SOUND_VOLUME: 'Громкость звуков',
  FIND_SYMBOL: 'Найдите символ',
  // other
  DIGIT_RANGE: 'Разрядность',
  FOR_WHOM: 'Для кого',
  REDUCE_TABLE: 'Уменьшить таблицу',
  // correct or wrong phrases when user solves samples

  OWL_SUCCESS_1: 'Когда правильно решил пример',
  OWL_SUCCESS_2: 'Просто отлично',
  OWL_SUCCESS_3: 'Ха, сделано ИЗИ',
  OWL_SUCCESS_4: 'Ты нереальный молодец',
  OWL_SUCCESS_5: 'Ответ верный',
  OWL_SUCCESS_6: 'Превосходная работа',
  OWL_SUCCESS_7: 'Сделал на 5',
  OWL_SUCCESS_8: 'Это просто топчик!',
  OWL_SUCCESS_9: 'Ты справился?!',
  OWL_SUCCESS_10: 'Супер-знания',
  OWL_SUCCESS_11: 'Го считать дальше',
  OWL_SUCCESS_12: 'Чётенько',
  OWL_SUCCESS_13: 'Изи катка',
  OWL_SUCCESS_14: 'YOSH!',
  OWL_SUCCESS_15: 'Невероятно!',
  OWL_SUCCESS_16: 'У тебя получилось!',
  OWL_SUCCESS_17: 'Самый верный ответ на диком западе',
  OWL_SUCCESS_18: 'Человек еще никогда не был так близко к совершенству!',

  OWL_FAILED_1: 'К сожалению, нет…',
  OWL_FAILED_2: 'Сегодня кто-то явно на чиле',
  OWL_FAILED_3: 'Оу май гад',
  OWL_FAILED_4: 'Ответ неверный…',
  OWL_FAILED_5: 'А ты записался добровольцем на ментальную арифметику?',
  OWL_FAILED_6: 'Варик-то неверный',
  OWL_FAILED_7: 'А вот и нет',
  OWL_FAILED_8: 'Еще одна попытка?',
  OWL_FAILED_9: 'Осуждаю',
  OWL_FAILED_10: 'Не расстраивайся...',
  OWL_FAILED_11: 'Попробуй еще раз…',
  OWL_FAILED_12: 'А ведь я верила в тебя...',
  OWL_FAILED_13: 'Опять...',
  OWL_FAILED_14: 'Если долго мучиться, что нибудь получится!',
  OWL_FAILED_15: 'Ну, штош',
  OWL_FAILED_16: 'Годы усилий, горы стараний, и все ради этого',
  OWL_FAILED_17: 'Что могло пойти не так в этот раз?',
  OWL_FAILED_18: 'В следующий раз получится!',
  // other
  FULLSCREEN: 'На весь экран',
  EXIT_FULLSCREEN: 'Свернуть',
  CURRENT_RANK: 'Сейчас твое звание:',
  // menu title
  PAST_WINNERS: 'Прошлые победители',
  WINNER_TABLE_CREATE_TITLE: 'Добавить нового победителя',
  EDIT_WINNER_TITLE: 'Редактировать победителя',
  CHOOSE_OLIMPIC_NAME: 'Выберите олимпиаду',
  CONFIRM_DELETE_WINNER: 'Вы действительно хотите удалить запись о победителе?',
  FILE_SIZE_ERROR: 'Выберите фото не более 3Мб',
  FILE_TYPE_ERROR:
    'Неверный тип файла. Пожалуйста, загрузите изображение (JPEG, PNG и т. д.).',
  SAVE_WINNERS_RESULT: 'Сохранить результаты',
  CONFIRM_SAVE_WINNERS:
    'Уверены, что хотите сохранить результаты? ВАЖНО! Должны быть проставлены места.',
  NO_PLACES_WARNING: 'Не проставлены места 0/1!',
  IMPORTANT_FIELDS_LOCKED:
    'Отредактировать имя, фамилию и дату рождения возможно только один раз. При возникновении вопросов обратитесь к администратору.',
  LOGIN_CHANGE_CONFIRM:
    'После редактирования почты в профиле поменялась почта для входа в личный кабинет.',
  TEMPLATES: 'Шаблоны',
  DIPLOMS_RECORDS_TEMPLATES: 'Шаблоны для записей в дипломы',
  MAIN_TEMPLATE: 'Шаблон по умолчанию',
  CONFIRM_DELETE_TEMPLATE: 'Вы действительно хотите удалить данный шаблон?',
  TEMPLATE_CREATE_TITLE: 'Создать шаблон',
  TEMPLATE_EDIT_TITLE: 'Редактировать шаблон',
  TEMPLATE_SUCCESS_CREATE_MESSAGE: 'Шаблон успешно создан',
  TEMPLATE_SUCCESS_EDIT_MESSAGE: 'Шаблон успешно изменен',
  ADD_STAGE: 'Добавить стадию',
  ADD_CATEGORY: 'Добавить категорию',
  VARIANT: 'Тип счёта',
  SHORT_RECORD: 'Короткая запись',
  CATEGORY_NAME: 'Название категории',
  CATEGORY_NAME_VALIDATION:
    'Название категории должно содержать только заглавные латинские буквы и цифры',
  SAMPLES_TYPE: 'Тип задания',
  TEMPLATE_FORM_TEXT: 'Выберите шаблон для записей в дипломы',
  // Рейтинг звезд
  BEST_STUDENTS: 'ЛУЧШИЕ УЧЕНИКИ',
  RESET_STARS: 'Обнулить звезды',
  OPEN_ALL: 'Открыть все',
  LOADING: 'Загрузка...',
  TAB_IN_SCHOOL: 'В школе',
  TAB_WITH_TEACHER: 'У педагога',
  TAB_IN_GROUP: 'В группе',
  NO_RATING_DATA: 'В рейтинге пока нет учеников',
  SCHOOL_STAR_RATING: 'Рейтинг школы',
  GROUPS_STAR_RATING: 'Рейтинг по группам',
  TEACHER_STAR_RATING: 'Рейтинг по педагогу',
  CONFIRM_RESET_STARS:
    'Вы уверены, что хотите обнулить звезды всем своим ученикам?',
  CONFIRM_RESET_SCHOOL_STARS:
    'Вы уверены, что хотите обнулить звезды этим ученикам?',
  RATING_SCHOOL_MESSAGE:
    'Выберите учеников (своих и учителей) для сброса звезд',
  NO_TEACHERS: 'Учителя не найдены',
  STAR_RATING_CLUE:
    'Звезды за ДЗ ваших учеников. Вы можете награждать учеников на свое усмотрение, повышая этим мотивацию детей. Призы, даты подведения итогов и кол-во мест на ваш выбор.',
  SETTING_ON: 'вкл',
  SMGL_USERS_TITLE: 'PAMA пользователи',
  OPERATION_COMPLETED: 'Операция выполнена',
  DELETED_COUNT: 'Удалено: {count}',
  SHOW_RATING_FOR_UAMAP: 'Показать рейтинг на Вамап',
  PAMA_GLOBAL_RATING: 'Рейтинг PAMA Global',
  SHOW_IN_ROW: 'Показать в ряд',
  PAMA_GLOBAL_PRINT: 'Печать заданий PAMA Global',
  PAMA_OFFLINE_OLIMPIC: 'Очная PAMA Global',
  PAMA_OFFLINE_FOR_STUDENT: 'Очная PAMA Global для ученика',
  PAMA_OFFLINE_FOR_TEACHER: 'Очная PAMA Global для педагога',
  MAINTAINER_PAMA: 'Сопровождающий PAMA Global',
  PAMA_OFFLINE_PARTICIPANTS: 'Участники Очной PAMA Global',
  PAMA_OFFLINE_OLIMPIC_PAYMENT: 'Покупка участия в Очной PAMA GLOBAL олимпиаде',
  MAINTAINER_PAMA_PAYMENT: 'Сопровождающий к Очной PAMA GLOBAL олимпиаде',
  PAMA_OFFLINE_OLIMPIC_PAY_PARTICIPATE:
    'Оплатить участие в очной PAMA Global олимпиаде',
  // ..
  PRACTICE_ON_TAB: 'Тренируйтесь на вкладке',
  WITH_ACTIVE_ACCESS: 'с активным доступом на нашей платформе',
  ACCOMPANY_PARTICIPANT_TEXT:
    'Если планируете сопровождать участника, приобретите билет и для него',
  CURRENT_COMPANION_LIMIT: 'Текущий лимит сопровождающих:',
  COMPANION_SALES_CLOSED: 'Продажа билетов для сопровождающих закрыта',
  PURCHASED_TEXT: 'Приобретено:',
  COMPANION_TICKET_ONE: 'билет',
  COMPANION_TICKET_TWO: 'билета',
  COMPANION_TICKET_FIVE: 'билетов',
  OF_COMPANIONS: 'сопровождающих',
  TICKET_DATA_WARNING:
    'Следующие данные будут использоваться для создания билета, проверьте правильность',
  TICKET_EMAIL_DELIVERY_PAMA:
    'На указанную почту должен быть выслан билет в установленные сроки.',
  TICKET_EMAIL_DELIVERY_OLIMPIC:
    'На указанную электронную почту должен быть выслан билет в течение 3-5 рабочих дней. Если этого не произошло, обратитесь в',
  TELEGRAM_LINK_TEXT: 'Телеграм',
  EDIT_PROFILE_IF_ERROR: 'В случае ошибки, отредактируйте свой профиль',
  PHOTO_UPLOAD_NOTICE:
    'Загрузите фото размером не более 10 Мб на любое облачное пространство. Скопируйте ссылку и вставьте сюда. Проверьте открыт ли доступ по ссылке.',
  SELECT_CATEGORY_PLACEHOLDER: 'Выберите категорию',
  SELECT_COUNTRY_PLACEHOLDER: 'Выберите страну',
  CATEGORY_WARNING:
    'Выбирайте категорию строго выше, если ранее занимали призовое место. Могут быть дисквалификации при несоблюдении правила.',
  MAINTAINERS_LIMIT_REACHED:
    'Максимальное количество сопровождающих достигнуто.',
  STUDENT_TABLE_REGISTER_NOTICE:
    'Обязательно зарегистрируйте пользователя на олимпиаду в его личном кабинете',
  COMPANION_REGISTRATION_REQUIRED:
    'Для покупки нужно зарегистрировать пользователя на олимпиаде',
  MAINTAINERS_ONE_PURCHASE: '1 Сопровождающий / Приобрести',
  MAINTAINERS_OTHER_PURCHASE: '{count} Сопровождающих / Приобрести',
  OFFICIAL_MODE: 'Переключить с тренировочных на официальные PAMA примеры',
  NUMBERS_TITLE: 'Числа на память',
  LENGTH_WORD: 'Длина',
  DIGITS_SHORT: 'зн.',
  PROGRESS_WORD: 'Прогресс',
  WRITE_ANSWER_INTERMEDIATE: 'Запишите ответ! Новое число через...',
  WRITE_ANSWER: 'Запишите ответ!',
  PAUSE: 'Пауза',
  CHECK_ANSWERS: 'Проверьте свои ответы.',
  STAGE_FINISHED: 'Этап завершен!',
  NUMBER_WORD: 'Число',
  buy_books: 'Купить учебники',
  CHAMPION_OF_CHAMPIONS: 'Суперчемпион',

  // new
  MAINTAINERS_REGISTRATION_FORM: 'Форма регистрации сопровождающих',
  REGISTER_MAINTAINERS: 'Зарегистрировать сопровождающих',
  HIDE_MAINTAINERS_FORM: 'Скрыть форму сопровождающих',
  MAINTAINERS_SUCCESS_SAVED: 'Сопровождающие успешно зарегистрированы',
  PHOTO_LINK_MAINTAINER: 'Ссылка на фото сопровождающего',
  RELATION: 'Роль',
  RELATION_PARENT: 'Родитель',
  RELATION_TEACHER: 'Педагог',
  MAINTAINERS_FILL_ALL_FIELDS:
    'Заполните все обязательные поля хотя бы для одного сопровождающего',
  MAINTAINERS: 'Сопровождающие',
  MAINTAINERS_LOADED_COUNT: 'Загружено сопровождающих: {count}',
  UNFILLED_MAINTAINERS: 'Незарег. Сопр.',
  EDIT_MAINTAINER: 'Редактирование сопровождающего',
  CONFIRM_DELETE_MAINTAINER:
    'Вы уверены, что хотите удалить этого сопровождающего? Счетчик билетов сопровождающих у участника будет уменьшен на 1.',
  FULL_NAME_EN: 'ФИО на английском',
  DONT_SHOW_AGAIN: 'Больше не показывать',
  PRINT_ALL_STAGES: 'Распечатать сразу все этапы',
};
